{
    "source": {
        "system": "dnd5e",
        "version": "5.2.5",
        "packs": ["dnd5e.monsters", "dnd5e.spells", "dnd5e.items"],
        "manifestSha256": "745a7f80f7d425c7b2acdf753dc524657a059d23e26f3d6463e4aece3b17ea9f"
    },
    "entries": [
        {
            "kind": "creature",
            "upstreamKey": "creature/srd_goat",
            "pack": "monsters",
            "compendiumId": "y8sRU8Ks2lcrGsaf",
            "name": "Goat",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_aboleth",
            "pack": "monsters",
            "compendiumId": "shhHtE7b92PefCWB",
            "name": "Aboleth",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_acolyte",
            "pack": "monsters",
            "compendiumId": "CHEUjiYrVM9X0vIT",
            "name": "Acolyte",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-black-dragon",
            "pack": "monsters",
            "compendiumId": "M4eX4Mu5IHCr3TMf",
            "name": "Adult Black Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-blue-dragon",
            "pack": "monsters",
            "compendiumId": "cGM3iVYTtCsYXjzO",
            "name": "Adult Blue Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-brass-dragon",
            "pack": "monsters",
            "compendiumId": "7vswgicsiMfS4ZTS",
            "name": "Adult Brass Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-bronze-dragon",
            "pack": "monsters",
            "compendiumId": "VCuG0Z3MrO8kfDU0",
            "name": "Adult Bronze Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-copper-dragon",
            "pack": "monsters",
            "compendiumId": "irz834sqAxRihtSG",
            "name": "Adult Copper Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-gold-dragon",
            "pack": "monsters",
            "compendiumId": "MO382D2sxtAIuUC5",
            "name": "Adult Gold Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-green-dragon",
            "pack": "monsters",
            "compendiumId": "GP8JMSDugRxuLOD2",
            "name": "Adult Green Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-red-dragon",
            "pack": "monsters",
            "compendiumId": "ZyIBOoZZD0nDaO2s",
            "name": "Adult Red Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-silver-dragon",
            "pack": "monsters",
            "compendiumId": "geM2F7HvVGhtk3h4",
            "name": "Adult Silver Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_adult-white-dragon",
            "pack": "monsters",
            "compendiumId": "3uIursokd3KdZrW3",
            "name": "Adult White Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_air-elemental",
            "pack": "monsters",
            "compendiumId": "banHjKDMCegbUwYE",
            "name": "Air Elemental",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-black-dragon",
            "pack": "monsters",
            "compendiumId": "qNdFhY3JOkCfhG3d",
            "name": "Ancient Black Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-blue-dragon",
            "pack": "monsters",
            "compendiumId": "SNT0JNVSngUTsj4m",
            "name": "Ancient Blue Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-brass-dragon",
            "pack": "monsters",
            "compendiumId": "pAuiNDr7nvpsW9nG",
            "name": "Ancient Brass Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-bronze-dragon",
            "pack": "monsters",
            "compendiumId": "35Y64PEFFdvQS0ra",
            "name": "Ancient Bronze Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-copper-dragon",
            "pack": "monsters",
            "compendiumId": "u0FWdplSOMTXGnN1",
            "name": "Ancient Copper Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-gold-dragon",
            "pack": "monsters",
            "compendiumId": "ckOF3vQrnjFnZIDU",
            "name": "Ancient Gold Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-green-dragon",
            "pack": "monsters",
            "compendiumId": "zjqjcRWKDMc59Tnx",
            "name": "Ancient Green Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-red-dragon",
            "pack": "monsters",
            "compendiumId": "vFeFRlF2FOgf2HIL",
            "name": "Ancient Red Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-silver-dragon",
            "pack": "monsters",
            "compendiumId": "gf9QbHdMAfvFtxcv",
            "name": "Ancient Silver Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ancient-white-dragon",
            "pack": "monsters",
            "compendiumId": "aTITHYYxthuZBPBn",
            "name": "Ancient White Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_androsphinx",
            "pack": "monsters",
            "compendiumId": "nEC1BRwM8Lx9hLXW",
            "name": "Androsphinx",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_animated-armor",
            "pack": "monsters",
            "compendiumId": "eORmAXuV5v3nWsQL",
            "name": "Animated Armor",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ankheg",
            "pack": "monsters",
            "compendiumId": "Wcsjbl25uiUsyQwn",
            "name": "Ankheg",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ape",
            "pack": "monsters",
            "compendiumId": "K5cKmPoFkpuOotis",
            "name": "Ape",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_archmage",
            "pack": "monsters",
            "compendiumId": "B7lBOr1AahNZs4a6",
            "name": "Archmage",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_assassin",
            "pack": "monsters",
            "compendiumId": "EMvcuOpu7ABCmBWi",
            "name": "Assassin",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_awakened-shrub",
            "pack": "monsters",
            "compendiumId": "gaSTr7DFZJLmgI2J",
            "name": "Awakened Shrub",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_awakened-tree",
            "pack": "monsters",
            "compendiumId": "UR2gWLFHmFwG7ReH",
            "name": "Awakened Tree",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_axe-beak",
            "pack": "monsters",
            "compendiumId": "SXXvwaLBNuzBymp3",
            "name": "Axe Beak",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_azer",
            "pack": "monsters",
            "compendiumId": "IiEDPMWqBlzkggYD",
            "name": "Azer",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_baboon",
            "pack": "monsters",
            "compendiumId": "JW8bXggOMBx1S6tF",
            "name": "Baboon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_badger",
            "pack": "monsters",
            "compendiumId": "oQvORD924obyPdCc",
            "name": "Badger",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_balor",
            "pack": "monsters",
            "compendiumId": "uZ8NrRenwYZ4qNf6",
            "name": "Balor",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_bandit",
            "pack": "monsters",
            "compendiumId": "n4TEv7inVUkyZviN",
            "name": "Bandit",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_bandit-captain",
            "pack": "monsters",
            "compendiumId": "rb7OJt822wIO52qY",
            "name": "Bandit Captain",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_barbed-devil",
            "pack": "monsters",
            "compendiumId": "sLdpiuaZF8lujJQy",
            "name": "Barbed Devil",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_basilisk",
            "pack": "monsters",
            "compendiumId": "hqj2yXtgwt64v3Lj",
            "name": "Basilisk",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_bat",
            "pack": "monsters",
            "compendiumId": "qav2dvMIUiMQCCsy",
            "name": "Bat",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_bearded-devil",
            "pack": "monsters",
            "compendiumId": "9ggQBmAKXraOtz7S",
            "name": "Bearded Devil",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_behir",
            "pack": "monsters",
            "compendiumId": "x47ZnpHfYl0ptDM9",
            "name": "Behir",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_berserker",
            "pack": "monsters",
            "compendiumId": "kz1t6xeXVwODpYb2",
            "name": "Berserker",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_black-bear",
            "pack": "monsters",
            "compendiumId": "D5WjGwKskeUT8HXa",
            "name": "Black Bear",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_black-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "IZMbiAHqQpzPo0CX",
            "name": "Black Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_black-pudding",
            "pack": "monsters",
            "compendiumId": "NwQpeeaMxAC3fRft",
            "name": "Black Pudding",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_blink-dog",
            "pack": "monsters",
            "compendiumId": "jOANE6M0My6UJF4e",
            "name": "Blink Dog",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_blood-hawk",
            "pack": "monsters",
            "compendiumId": "AJiJW7K957aJJCN6",
            "name": "Blood Hawk",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_blue-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "najtPRiHLR6buSWe",
            "name": "Blue Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_boar",
            "pack": "monsters",
            "compendiumId": "lZR4lhNmYSf89s4Q",
            "name": "Boar",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_bone-devil",
            "pack": "monsters",
            "compendiumId": "AnseLn7HwuP97grf",
            "name": "Bone Devil",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_brass-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "azCbLQt5LAYwTI7U",
            "name": "Brass Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_bronze-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "hY9ptpO5Xl2tfkcj",
            "name": "Bronze Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_brown-bear",
            "pack": "monsters",
            "compendiumId": "omcDpBoB69esCXeM",
            "name": "Brown Bear",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_bugbear",
            "pack": "monsters",
            "compendiumId": "QtJairF0h18BRhEM",
            "name": "Bugbear",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_bulette",
            "pack": "monsters",
            "compendiumId": "1ES45ODWg3pCrkzv",
            "name": "Bulette",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_camel",
            "pack": "monsters",
            "compendiumId": "FQMFuzzSh73d0Nrd",
            "name": "Camel",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_cat",
            "pack": "monsters",
            "compendiumId": "hIf83RD3ZVW4Egfi",
            "name": "Cat",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_centaur",
            "pack": "monsters",
            "compendiumId": "5kZNNWzZ6HrfKuWf",
            "name": "Centaur",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_chain-devil",
            "pack": "monsters",
            "compendiumId": "KtM6IV9I5l1MWUDk",
            "name": "Chain Devil",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_chimera",
            "pack": "monsters",
            "compendiumId": "kr6r8bhSehACPfZ8",
            "name": "Chimera",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_chuul",
            "pack": "monsters",
            "compendiumId": "P6qC8jB3pnEH0tIE",
            "name": "Chuul",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_clay-golem",
            "pack": "monsters",
            "compendiumId": "YOqhbf8WsX0jH9Fu",
            "name": "Clay Golem",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_cloaker",
            "pack": "monsters",
            "compendiumId": "HPUO3weiwRQnql0d",
            "name": "Cloaker",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_cloud-giant",
            "pack": "monsters",
            "compendiumId": "Aw2wmqGIatxe2ImI",
            "name": "Cloud Giant",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_cockatrice",
            "pack": "monsters",
            "compendiumId": "EpYl7qifM5pq6W6B",
            "name": "Cockatrice",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_commoner",
            "pack": "monsters",
            "compendiumId": "SqZRuJ8lt2KGJBbq",
            "name": "Commoner",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_constrictor-snake",
            "pack": "monsters",
            "compendiumId": "UTuKdTah1DKfPwWe",
            "name": "Constrictor Snake",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_copper-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "AyvniEKtyroOe83p",
            "name": "Copper Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_couatl",
            "pack": "monsters",
            "compendiumId": "ZaP1H91t4FzbRqR5",
            "name": "Couatl",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_crab",
            "pack": "monsters",
            "compendiumId": "8RgUhb31VvjUNZU1",
            "name": "Crab",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_crocodile",
            "pack": "monsters",
            "compendiumId": "8aCTKP5qaBPFOqxM",
            "name": "Crocodile",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_cult-fanatic",
            "pack": "monsters",
            "compendiumId": "tYfQIxCJT0WaaKmc",
            "name": "Cult Fanatic",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_cultist",
            "pack": "monsters",
            "compendiumId": "qkLNA1lKMMJpxuWg",
            "name": "Cultist",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_darkmantle",
            "pack": "monsters",
            "compendiumId": "g7FSu2oU4YHPgWNA",
            "name": "Darkmantle",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_death-dog",
            "pack": "monsters",
            "compendiumId": "PH78NBdvoaszAb61",
            "name": "Death Dog",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_deep-gnome-svirfneblin",
            "pack": "monsters",
            "compendiumId": "ZM1P6LoYSwMiIJN9",
            "name": "Deep Gnome",
            "match": "manual"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_deer",
            "pack": "monsters",
            "compendiumId": "4EODJbmPlpnNGVR7",
            "name": "Deer",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_deva",
            "pack": "monsters",
            "compendiumId": "m4H3hjamBNMH09S9",
            "name": "Deva",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_dire-wolf",
            "pack": "monsters",
            "compendiumId": "EYiQZ3rFL25fEJY5",
            "name": "Dire Wolf",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_djinni",
            "pack": "monsters",
            "compendiumId": "5P1VGAZQwOilwZQf",
            "name": "Djinni",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_doppelganger",
            "pack": "monsters",
            "compendiumId": "mWbrPhcKOz6oLXMV",
            "name": "Doppelganger",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_draft-horse",
            "pack": "monsters",
            "compendiumId": "Bupo3E9X5Ptx6XeT",
            "name": "Draft Horse",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_dragon-turtle",
            "pack": "monsters",
            "compendiumId": "ijsfYEDqSuwQXwNN",
            "name": "Dragon Turtle",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_dretch",
            "pack": "monsters",
            "compendiumId": "kz2fW9xb5CcvXLX4",
            "name": "Dretch",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_drider",
            "pack": "monsters",
            "compendiumId": "1OQbxoZI5BtlB2ME",
            "name": "Drider",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_drow",
            "pack": "monsters",
            "compendiumId": "1vaBSMUfOy6JPJ14",
            "name": "Drow",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_druid",
            "pack": "monsters",
            "compendiumId": "K15Yl8JmB5iPircc",
            "name": "Druid",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_dryad",
            "pack": "monsters",
            "compendiumId": "KOHVWl5RU9XBR8Jb",
            "name": "Dryad",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_duergar",
            "pack": "monsters",
            "compendiumId": "iGBdQA3IuKsurcUy",
            "name": "Duergar",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_dust-mephit",
            "pack": "monsters",
            "compendiumId": "BUCfQ7ihaXX75Vai",
            "name": "Dust Mephit",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_eagle",
            "pack": "monsters",
            "compendiumId": "EI8w6XjzCZICkox9",
            "name": "Eagle",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_earth-elemental",
            "pack": "monsters",
            "compendiumId": "sApYLZj9PTZ40wJr",
            "name": "Earth Elemental",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_efreeti",
            "pack": "monsters",
            "compendiumId": "LTomFUTBrkRi0Pj5",
            "name": "Efreeti",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_elephant",
            "pack": "monsters",
            "compendiumId": "jLPhaBnMtAbB5dp1",
            "name": "Elephant",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_elk",
            "pack": "monsters",
            "compendiumId": "55PkbskG5iBZGrgR",
            "name": "Elk",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_erinyes",
            "pack": "monsters",
            "compendiumId": "3o2rQBqpzjIHmrBW",
            "name": "Erinyes",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ettercap",
            "pack": "monsters",
            "compendiumId": "aKt7vFAS1J0x3FQm",
            "name": "Ettercap",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ettin",
            "pack": "monsters",
            "compendiumId": "KLCkHep28HBfdsky",
            "name": "Ettin",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_fire-elemental",
            "pack": "monsters",
            "compendiumId": "8SMQl75HLjhuSeau",
            "name": "Fire Elemental",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_fire-giant",
            "pack": "monsters",
            "compendiumId": "45Z5kogZEhawX1Ey",
            "name": "Fire Giant",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_flesh-golem",
            "pack": "monsters",
            "compendiumId": "Hm4o2FgPZsdbXjLq",
            "name": "Flesh Golem",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_flying-snake",
            "pack": "monsters",
            "compendiumId": "SMfgOsfPgf6rb01k",
            "name": "Flying Snake",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_flying-sword",
            "pack": "monsters",
            "compendiumId": "EqJUA3Z3181RSSFU",
            "name": "Flying Sword",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_frog",
            "pack": "monsters",
            "compendiumId": "EZgiprHXA2D7Uyb3",
            "name": "Frog",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_frost-giant",
            "pack": "monsters",
            "compendiumId": "Buxe6dDK5Mw7kxe6",
            "name": "Frost Giant",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_gargoyle",
            "pack": "monsters",
            "compendiumId": "0m8QyDN52qw9zzOM",
            "name": "Gargoyle",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_gelatinous-cube",
            "pack": "monsters",
            "compendiumId": "3fzQVYQhXxCXRa2o",
            "name": "Gelatinous Cube",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ghast",
            "pack": "monsters",
            "compendiumId": "IyIybE5t2adMEVUM",
            "name": "Ghast",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ghost",
            "pack": "monsters",
            "compendiumId": "qoFEjfrANBdrCP6m",
            "name": "Ghost",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ghoul",
            "pack": "monsters",
            "compendiumId": "OBujQLLPSmlJiZnL",
            "name": "Ghoul",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-ape",
            "pack": "monsters",
            "compendiumId": "8MuL8xisavJW9bnw",
            "name": "Giant Ape",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-badger",
            "pack": "monsters",
            "compendiumId": "cJGY1ZywUOo6heNR",
            "name": "Giant Badger",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-bat",
            "pack": "monsters",
            "compendiumId": "SoK7l5zJQKxTVgLL",
            "name": "Giant Bat",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-boar",
            "pack": "monsters",
            "compendiumId": "SsuCaF2fIEoDdFA3",
            "name": "Giant Boar",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-centipede",
            "pack": "monsters",
            "compendiumId": "Hn8FFLEzscgT7azz",
            "name": "Giant Centipede",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-constrictor-snake",
            "pack": "monsters",
            "compendiumId": "NpvwE1feOHyEqAbP",
            "name": "Giant Constrictor Snake",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-crab",
            "pack": "monsters",
            "compendiumId": "AOJvmk1IchxNxQzP",
            "name": "Giant Crab",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-crocodile",
            "pack": "monsters",
            "compendiumId": "3YwmvDupMwycWNCO",
            "name": "Giant Crocodile",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-eagle",
            "pack": "monsters",
            "compendiumId": "9bHoR8k5D2DKHaF3",
            "name": "Giant Eagle",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-elk",
            "pack": "monsters",
            "compendiumId": "hQt3qIahnB1Odb40",
            "name": "Giant Elk",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-fire-beetle",
            "pack": "monsters",
            "compendiumId": "Z0GiAv3bJxTjUfjM",
            "name": "Giant Fire Beetle",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-frog",
            "pack": "monsters",
            "compendiumId": "kSAi2KRonL4G4JpO",
            "name": "Giant Frog",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-goat",
            "pack": "monsters",
            "compendiumId": "rjqk7ToMD8sGr3n4",
            "name": "Giant Goat",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-hyena",
            "pack": "monsters",
            "compendiumId": "aAqfEHPiVbhMwZ6j",
            "name": "Giant Hyena",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-lizard",
            "pack": "monsters",
            "compendiumId": "pLzSh4dA517Tn73E",
            "name": "Giant Lizard",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-octopus",
            "pack": "monsters",
            "compendiumId": "p9Xnr820UAZBOIVN",
            "name": "Giant Octopus",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-owl",
            "pack": "monsters",
            "compendiumId": "VVXly3ue0i3YgGrB",
            "name": "Giant Owl",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-poisonous-snake",
            "pack": "monsters",
            "compendiumId": "ZW39DE2zI3TXVYC9",
            "name": "Giant Poisonous Snake",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-rat",
            "pack": "monsters",
            "compendiumId": "q1YJIeIt6rK8fCKn",
            "name": "Giant Rat",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-rat-diseased",
            "pack": "monsters",
            "compendiumId": "z0zvgcIugizwcuxJ",
            "name": "Giant Rat (Diseased)",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-scorpion",
            "pack": "monsters",
            "compendiumId": "GxgIVRX5GbVTifiF",
            "name": "Giant Scorpion",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-sea-horse",
            "pack": "monsters",
            "compendiumId": "c9XDGsTJRy9HUaxQ",
            "name": "Giant Sea Horse",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-shark",
            "pack": "monsters",
            "compendiumId": "MWlwLlKXh8jUUxOL",
            "name": "Giant Shark",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-spider",
            "pack": "monsters",
            "compendiumId": "v99wOosUJjUgcUNF",
            "name": "Giant Spider",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-toad",
            "pack": "monsters",
            "compendiumId": "Ixo5shumxy4I9qyD",
            "name": "Giant Toad",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-vulture",
            "pack": "monsters",
            "compendiumId": "4ZlUHt4xmB7GdPfk",
            "name": "Giant Vulture",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-wasp",
            "pack": "monsters",
            "compendiumId": "4tl0s2SnaLjkoDiI",
            "name": "Giant Wasp",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-weasel",
            "pack": "monsters",
            "compendiumId": "8VXxqeBvN54rPh81",
            "name": "Giant Weasel",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_giant-wolf-spider",
            "pack": "monsters",
            "compendiumId": "f9JbhBfWucrY2eDA",
            "name": "Giant Wolf Spider",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_gibbering-mouther",
            "pack": "monsters",
            "compendiumId": "8pX2JhWUpTNNRBVx",
            "name": "Gibbering Mouther",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_glabrezu",
            "pack": "monsters",
            "compendiumId": "OGPHF4sCVOAi87TU",
            "name": "Glabrezu",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_gladiator",
            "pack": "monsters",
            "compendiumId": "fsPruAIDOg4tVrgb",
            "name": "Gladiator",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_gnoll",
            "pack": "monsters",
            "compendiumId": "R2GPY9BhRmmwZwkh",
            "name": "Gnoll",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_goblin",
            "pack": "monsters",
            "compendiumId": "TjWQOgI3A4UAl7lC",
            "name": "Goblin",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_gold-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "naSoHU9KbkgeNIwB",
            "name": "Gold Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_gorgon",
            "pack": "monsters",
            "compendiumId": "nZthq6WHLhcdu3te",
            "name": "Gorgon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_gray-ooze",
            "pack": "monsters",
            "compendiumId": "fqbFYtbtkrL53FOC",
            "name": "Gray Ooze",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_green-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "KH6ZrUiUOKQCOlRH",
            "name": "Green Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_green-hag",
            "pack": "monsters",
            "compendiumId": "saq6WM959pKHuaqP",
            "name": "Green Hag",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_grick",
            "pack": "monsters",
            "compendiumId": "tFJX45zj3QDc3Zli",
            "name": "Grick",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_griffon",
            "pack": "monsters",
            "compendiumId": "h052EIIUmRwJum65",
            "name": "Griffon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_grimlock",
            "pack": "monsters",
            "compendiumId": "GpeQYtlo8oGvGlkM",
            "name": "Grimlock",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_guard",
            "pack": "monsters",
            "compendiumId": "E9CvDPDg5dFEpVjS",
            "name": "Guard",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_guardian-naga",
            "pack": "monsters",
            "compendiumId": "8ExSFCar5Lbhdo7u",
            "name": "Guardian Naga",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_gynosphinx",
            "pack": "monsters",
            "compendiumId": "6wbasdWWqtXeIAyD",
            "name": "Gynosphinx",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_half-red-dragon-veteran",
            "pack": "monsters",
            "compendiumId": "5TmstVMURpVtmNR3",
            "name": "Half-Red Dragon Veteran",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_harpy",
            "pack": "monsters",
            "compendiumId": "CqQ6pXQA5WXZNOm3",
            "name": "Harpy",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_hawk",
            "pack": "monsters",
            "compendiumId": "fnkPNfIpS62LqOu4",
            "name": "Hawk",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_hell-hound",
            "pack": "monsters",
            "compendiumId": "iSCL4Q82ivnYelzc",
            "name": "Hell Hound",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_hezrou",
            "pack": "monsters",
            "compendiumId": "ec3lhsNv1ZRu7Qaq",
            "name": "Hezrou",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_hill-giant",
            "pack": "monsters",
            "compendiumId": "9g4N9sjyh8Ql46to",
            "name": "Hill Giant",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_hippogriff",
            "pack": "monsters",
            "compendiumId": "T2PExQE84ZcIbAXz",
            "name": "Hippogriff",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_hobgoblin",
            "pack": "monsters",
            "compendiumId": "6qnT52lZtZblgGw8",
            "name": "Hobgoblin",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_homunculus",
            "pack": "monsters",
            "compendiumId": "ZQTCZfTV9ZoTjNCU",
            "name": "Homunculus",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_horned-devil",
            "pack": "monsters",
            "compendiumId": "MADGs8pWMVyyFOf1",
            "name": "Horned Devil",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_hunter-shark",
            "pack": "monsters",
            "compendiumId": "siBUEAj4UVdaiH6p",
            "name": "Hunter Shark",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_hydra",
            "pack": "monsters",
            "compendiumId": "K4vsSlHqbBAHUDHY",
            "name": "Hydra",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_hyena",
            "pack": "monsters",
            "compendiumId": "cDr1JtzEV26bP5Ym",
            "name": "Hyena",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ice-devil",
            "pack": "monsters",
            "compendiumId": "1zzRQps9jZdLZGqI",
            "name": "Ice Devil",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ice-mephit",
            "pack": "monsters",
            "compendiumId": "ESEm3fGUfSKjzVUc",
            "name": "Ice Mephit",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_imp",
            "pack": "monsters",
            "compendiumId": "dLQiESMsfsXijD5c",
            "name": "Imp",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_invisible-stalker",
            "pack": "monsters",
            "compendiumId": "oDspGxRQFBhE74L2",
            "name": "Invisible Stalker",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_iron-golem",
            "pack": "monsters",
            "compendiumId": "h98AuPfomEPcCibP",
            "name": "Iron Golem",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_jackal",
            "pack": "monsters",
            "compendiumId": "MZYCPIVoBs918qGZ",
            "name": "Jackal",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_killer-whale",
            "pack": "monsters",
            "compendiumId": "ciLSItjCpwT7nMmk",
            "name": "Killer Whale",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_knight",
            "pack": "monsters",
            "compendiumId": "D5UqYD1EnTrJaMTO",
            "name": "Knight",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_kobold",
            "pack": "monsters",
            "compendiumId": "5ngbctIMeEnuC1p1",
            "name": "Kobold",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_kraken",
            "pack": "monsters",
            "compendiumId": "kVg37NlPcACAzjCT",
            "name": "Kraken",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_lamia",
            "pack": "monsters",
            "compendiumId": "MnoL59nOOfYatAkQ",
            "name": "Lamia",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_lemure",
            "pack": "monsters",
            "compendiumId": "tubcO7kaQ4w0soxS",
            "name": "Lemure",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_lich",
            "pack": "monsters",
            "compendiumId": "bfh29vIEoGzI240e",
            "name": "Lich",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_lion",
            "pack": "monsters",
            "compendiumId": "hjhERRzafCiFFVLA",
            "name": "Lion",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_lizard",
            "pack": "monsters",
            "compendiumId": "I2x01hzOjVN4NUjf",
            "name": "Lizard",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_lizardfolk",
            "pack": "monsters",
            "compendiumId": "57DofLgRQx16ARoc",
            "name": "Lizardfolk",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_mage",
            "pack": "monsters",
            "compendiumId": "mQnsXanewsPiV7QE",
            "name": "Mage",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_magma-mephit",
            "pack": "monsters",
            "compendiumId": "oJCOB9X2BPsBkWW5",
            "name": "Magma Mephit",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_magmin",
            "pack": "monsters",
            "compendiumId": "8MD1vRBTcgSXXk3u",
            "name": "Magmin",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_mammoth",
            "pack": "monsters",
            "compendiumId": "MiYRAIHwm9It1in8",
            "name": "Mammoth",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_manticore",
            "pack": "monsters",
            "compendiumId": "MAoCGF5VkQwhmgvI",
            "name": "Manticore",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_marilith",
            "pack": "monsters",
            "compendiumId": "egsSDYbqoLCelb0J",
            "name": "Marilith",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_mastiff",
            "pack": "monsters",
            "compendiumId": "YTpL2c3NO4sOn2UA",
            "name": "Mastiff",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_medusa",
            "pack": "monsters",
            "compendiumId": "eiifqZwYGi71r2Yl",
            "name": "Medusa",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_merfolk",
            "pack": "monsters",
            "compendiumId": "KUpbXdn1XmHEeOPk",
            "name": "Merfolk",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_merrow",
            "pack": "monsters",
            "compendiumId": "1cwfYaACm5F0l4y3",
            "name": "Merrow",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_mimic",
            "pack": "monsters",
            "compendiumId": "hx240PG5r5qpRet3",
            "name": "Mimic",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_minotaur",
            "pack": "monsters",
            "compendiumId": "pOPQU4UnR27zA0jf",
            "name": "Minotaur",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_minotaur-skeleton",
            "pack": "monsters",
            "compendiumId": "xple5bvGj42uGgdd",
            "name": "Minotaur Skeleton",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_mule",
            "pack": "monsters",
            "compendiumId": "Vk7uHVkJ5b26gaTh",
            "name": "Mule",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_mummy",
            "pack": "monsters",
            "compendiumId": "t8WYD7ak07X7xpx8",
            "name": "Mummy",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_mummy-lord",
            "pack": "monsters",
            "compendiumId": "UFW8M3JHzHkxUEGM",
            "name": "Mummy Lord",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_nalfeshnee",
            "pack": "monsters",
            "compendiumId": "rUg5JMnKNnZNBAq9",
            "name": "Nalfeshnee",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_night-hag",
            "pack": "monsters",
            "compendiumId": "xvh2UOKv1bh03Gih",
            "name": "Night Hag",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_nightmare",
            "pack": "monsters",
            "compendiumId": "5SgVGhQBswgWRwsF",
            "name": "Nightmare",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_noble",
            "pack": "monsters",
            "compendiumId": "GlaCGcgIP6YjBjGc",
            "name": "Noble",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ochre-jelly",
            "pack": "monsters",
            "compendiumId": "xBhG7Dos3tkg9jWz",
            "name": "Ochre Jelly",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_octopus",
            "pack": "monsters",
            "compendiumId": "3UUNbGiG2Yf1ZPxM",
            "name": "Octopus",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ogre",
            "pack": "monsters",
            "compendiumId": "eIGowKTkEBC9gUzx",
            "name": "Ogre",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_ogre-zombie",
            "pack": "monsters",
            "compendiumId": "RenLfmDT2XlbCF4x",
            "name": "Ogre Zombie",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_oni",
            "pack": "monsters",
            "compendiumId": "L1w8yBkInMscfJ3F",
            "name": "Oni",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_orc",
            "pack": "monsters",
            "compendiumId": "HB49mCOVBXwWeKWQ",
            "name": "Orc",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_otyugh",
            "pack": "monsters",
            "compendiumId": "jcZblJ6lqtW0ePxe",
            "name": "Otyugh",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_owl",
            "pack": "monsters",
            "compendiumId": "d0prpsGSAorDadec",
            "name": "Owl",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_owlbear",
            "pack": "monsters",
            "compendiumId": "zY3W5MG7FjssENf6",
            "name": "Owlbear",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_panther",
            "pack": "monsters",
            "compendiumId": "AijNdqMurWxDxUSl",
            "name": "Panther",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_pegasus",
            "pack": "monsters",
            "compendiumId": "EIgAW1dWVPpyWLUh",
            "name": "Pegasus",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_phase-spider",
            "pack": "monsters",
            "compendiumId": "llSG0Hi4eGlRlQ4o",
            "name": "Phase Spider",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_pit-fiend",
            "pack": "monsters",
            "compendiumId": "RCv5y7iWlfNxkinx",
            "name": "Pit Fiend",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_planetar",
            "pack": "monsters",
            "compendiumId": "XEByBLeOkDgL3mrr",
            "name": "Planetar",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_plesiosaurus",
            "pack": "monsters",
            "compendiumId": "4OeZZguYgJcsZoM9",
            "name": "Plesiosaurus",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_poisonous-snake",
            "pack": "monsters",
            "compendiumId": "D5rwVIxmfFrdyyxT",
            "name": "Poisonous Snake",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_polar-bear",
            "pack": "monsters",
            "compendiumId": "hb6pjvdCNYmLLp8V",
            "name": "Polar Bear",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_pony",
            "pack": "monsters",
            "compendiumId": "PHO4J98zK2p4KNyc",
            "name": "Pony",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_priest",
            "pack": "monsters",
            "compendiumId": "PVD5wRdyO7iCJPs1",
            "name": "Priest",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_pseudodragon",
            "pack": "monsters",
            "compendiumId": "fkCNtbvPOMd7mipF",
            "name": "Pseudodragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_purple-worm",
            "pack": "monsters",
            "compendiumId": "PtotS52HpHX596cZ",
            "name": "Purple Worm",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_quasit",
            "pack": "monsters",
            "compendiumId": "bwtkdzavdNHISgp4",
            "name": "Quasit",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_quipper",
            "pack": "monsters",
            "compendiumId": "nkyCGJ9wXeAZkyyz",
            "name": "Quipper",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_rakshasa",
            "pack": "monsters",
            "compendiumId": "qXzMsRTHEodqO8l2",
            "name": "Rakshasa",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_rat",
            "pack": "monsters",
            "compendiumId": "pozQUPTnLZW8epox",
            "name": "Rat",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_raven",
            "pack": "monsters",
            "compendiumId": "LPdX5YLlwci0NDZx",
            "name": "Raven",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_red-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "zgWkII3VoE4AHCND",
            "name": "Red Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_reef-shark",
            "pack": "monsters",
            "compendiumId": "F0yILX4xKKt4dxKY",
            "name": "Reef Shark",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_remorhaz",
            "pack": "monsters",
            "compendiumId": "VBzqw2rOUvTuNOPI",
            "name": "Remorhaz",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_rhinoceros",
            "pack": "monsters",
            "compendiumId": "SBCe2BSa6opTS5M4",
            "name": "Rhinoceros",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_riding-horse",
            "pack": "monsters",
            "compendiumId": "rz8UTUnFT87BsAFR",
            "name": "Riding Horse",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_roc",
            "pack": "monsters",
            "compendiumId": "p980augbCIdpK9ZX",
            "name": "Roc",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_roper",
            "pack": "monsters",
            "compendiumId": "qZyLwdx7lj5d1wfD",
            "name": "Roper",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_rug-of-smothering",
            "pack": "monsters",
            "compendiumId": "f6HaKROPIcBRmSd1",
            "name": "Rug of Smothering",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_rust-monster",
            "pack": "monsters",
            "compendiumId": "WJsxqbHU28D64lWT",
            "name": "Rust Monster",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_saber-toothed-tiger",
            "pack": "monsters",
            "compendiumId": "tYYoifu9teGLetVI",
            "name": "Saber-Toothed Tiger",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_sahuagin",
            "pack": "monsters",
            "compendiumId": "lyNBFmJdbh4NLRzz",
            "name": "Sahuagin",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_salamander",
            "pack": "monsters",
            "compendiumId": "yVNPVJIBpQ2Mp3Xa",
            "name": "Salamander",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_satyr",
            "pack": "monsters",
            "compendiumId": "8xhuJXYMnlQD7LF6",
            "name": "Satyr",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_scorpion",
            "pack": "monsters",
            "compendiumId": "Y0vxQVF7w2P38FK2",
            "name": "Scorpion",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_scout",
            "pack": "monsters",
            "compendiumId": "O3ABqI55Ir1du1Xa",
            "name": "Scout",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_sea-hag",
            "pack": "monsters",
            "compendiumId": "OQqybZoMeDFn5AFD",
            "name": "Sea Hag",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_sea-horse",
            "pack": "monsters",
            "compendiumId": "FWSDiq9SZsdiBAa8",
            "name": "Sea Horse",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_shadow",
            "pack": "monsters",
            "compendiumId": "QGcQYZbVl4bWzi4E",
            "name": "Shadow",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_shambling-mound",
            "pack": "monsters",
            "compendiumId": "gGeLeV411iQ5Yijs",
            "name": "Shambling Mound",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_shield-guardian",
            "pack": "monsters",
            "compendiumId": "z85EsGS2GVWj46qE",
            "name": "Shield Guardian",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_shrieker",
            "pack": "monsters",
            "compendiumId": "TaK6nQMGqZ0y8gt7",
            "name": "Shrieker",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_silver-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "J1QVPd8POvcPaqx4",
            "name": "Silver Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_skeleton",
            "pack": "monsters",
            "compendiumId": "nU8GN8La8DCt8SDb",
            "name": "Skeleton",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_solar",
            "pack": "monsters",
            "compendiumId": "lOYt73eaJojBDxAV",
            "name": "Solar",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_specter",
            "pack": "monsters",
            "compendiumId": "PuPo4H4Dcxigf0fY",
            "name": "Specter",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_spider",
            "pack": "monsters",
            "compendiumId": "28gU50HtG8Kp7uIz",
            "name": "Spider",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_spirit-naga",
            "pack": "monsters",
            "compendiumId": "BAT6ld8qJZetpycL",
            "name": "Spirit Naga",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_sprite",
            "pack": "monsters",
            "compendiumId": "MUpBNDoJEr09bLaO",
            "name": "Sprite",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_spy",
            "pack": "monsters",
            "compendiumId": "13K3XK2A3wwxVKLD",
            "name": "Spy",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_steam-mephit",
            "pack": "monsters",
            "compendiumId": "UthHOT7QfZfEIUue",
            "name": "Steam Mephit",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_stirge",
            "pack": "monsters",
            "compendiumId": "gKRtiMNAjZiCVfwz",
            "name": "Stirge",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_stone-giant",
            "pack": "monsters",
            "compendiumId": "SOin81NWijHRvXFK",
            "name": "Stone Giant",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_stone-golem",
            "pack": "monsters",
            "compendiumId": "z3gSIXHHWYaHjfBT",
            "name": "Stone Golem",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_storm-giant",
            "pack": "monsters",
            "compendiumId": "68bAMIpe4jvDeR9G",
            "name": "Storm Giant",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_succubusincubus",
            "pack": "monsters",
            "compendiumId": "VmdyZDjqAc8vdncY",
            "name": "Succubus/Incubus",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-bats",
            "pack": "monsters",
            "compendiumId": "PcZ0QjIG6bHpffp9",
            "name": "Swarm of Bats",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-beetles",
            "pack": "monsters",
            "compendiumId": "dZZFmG8LiBlgWi76",
            "name": "Swarm of Beetles",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-centipedes",
            "pack": "monsters",
            "compendiumId": "KC4tYOolARhajP18",
            "name": "Swarm of Centipedes",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-insects",
            "pack": "monsters",
            "compendiumId": "S0zDrv6lbnwWaz9E",
            "name": "Swarm of Insects",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-poisonous-snakes",
            "pack": "monsters",
            "compendiumId": "XfQMBoTh892XSnCX",
            "name": "Swarm of Poisonous Snakes",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-quippers",
            "pack": "monsters",
            "compendiumId": "KXG5XLIwKhn1V0Y5",
            "name": "Swarm of Quippers",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-rats",
            "pack": "monsters",
            "compendiumId": "8ihbbjkaOFTPbI73",
            "name": "Swarm of Rats",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-ravens",
            "pack": "monsters",
            "compendiumId": "g40zN6xMye6bSS94",
            "name": "Swarm of Ravens",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-spiders",
            "pack": "monsters",
            "compendiumId": "4udpeEneFSZK9NTB",
            "name": "Swarm of Spiders",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_swarm-of-wasps",
            "pack": "monsters",
            "compendiumId": "YUaprnengdFDNG8P",
            "name": "Swarm of Wasps",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_tarrasque",
            "pack": "monsters",
            "compendiumId": "KCvt4FdOVJbuZ3T0",
            "name": "Tarrasque",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_thug",
            "pack": "monsters",
            "compendiumId": "Cy3A0rsNMPLZozam",
            "name": "Thug",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_tiger",
            "pack": "monsters",
            "compendiumId": "FayqbnjBMszO6Pat",
            "name": "Tiger",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_treant",
            "pack": "monsters",
            "compendiumId": "NB6wUgVqeOQtsQKu",
            "name": "Treant",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_tribal-warrior",
            "pack": "monsters",
            "compendiumId": "nREPw9g94Bsb9sIl",
            "name": "Tribal Warrior",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_triceratops",
            "pack": "monsters",
            "compendiumId": "e5IQxSJO7ySEDdSH",
            "name": "Triceratops",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_troll",
            "pack": "monsters",
            "compendiumId": "ZHAFrnCwCz17dmLc",
            "name": "Troll",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_tyrannosaurus-rex",
            "pack": "monsters",
            "compendiumId": "HlddcPm4cWptj3ka",
            "name": "Tyrannosaurus Rex",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_unicorn",
            "pack": "monsters",
            "compendiumId": "G9PENY6nw0xRxCJW",
            "name": "Unicorn",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_vampire",
            "pack": "monsters",
            "compendiumId": "DDO9lDCDtNHkfShP",
            "name": "Vampire",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_vampire-spawn",
            "pack": "monsters",
            "compendiumId": "zpaZb7I8alY32vWV",
            "name": "Vampire Spawn",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_veteran",
            "pack": "monsters",
            "compendiumId": "J8xjoG4Dxb8WkHtV",
            "name": "Veteran",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_violet-fungus",
            "pack": "monsters",
            "compendiumId": "7EmUVycEASn7SFL0",
            "name": "Violet Fungus",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_vrock",
            "pack": "monsters",
            "compendiumId": "6oc29m5uzzzb0pk3",
            "name": "Vrock",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_vulture",
            "pack": "monsters",
            "compendiumId": "fkJ8Z8zi2JtlcHh9",
            "name": "Vulture",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_warhorse",
            "pack": "monsters",
            "compendiumId": "T1xZTDCGuvMBSq8d",
            "name": "Warhorse",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_warhorse-skeleton",
            "pack": "monsters",
            "compendiumId": "7KJ5vjnp0FJrdu6T",
            "name": "Warhorse Skeleton",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_water-elemental",
            "pack": "monsters",
            "compendiumId": "namJz755U1EhvEJa",
            "name": "Water Elemental",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_weasel",
            "pack": "monsters",
            "compendiumId": "WOdeacKCYVhgLDuN",
            "name": "Weasel",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_werebear",
            "pack": "monsters",
            "compendiumId": "oRBnO5OHoOZzlCOr",
            "name": "Werebear",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_wereboar",
            "pack": "monsters",
            "compendiumId": "J9hgSaZODGjrNl9B",
            "name": "Wereboar",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_wererat",
            "pack": "monsters",
            "compendiumId": "CrnUJhTbkdZjCZsH",
            "name": "Wererat",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_weretiger",
            "pack": "monsters",
            "compendiumId": "zIr3NaNF0mWz5Ahq",
            "name": "Weretiger",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_werewolf",
            "pack": "monsters",
            "compendiumId": "7tRhrxuknTpHpYcA",
            "name": "Werewolf",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_white-dragon-wyrmling",
            "pack": "monsters",
            "compendiumId": "vc2TAgIuq4yInjbf",
            "name": "White Dragon Wyrmling",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_wight",
            "pack": "monsters",
            "compendiumId": "rbyp54px2D0ql4QK",
            "name": "Wight",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_will-o-wisp",
            "pack": "monsters",
            "compendiumId": "8KSVpQZyzius93ko",
            "name": "Will-o'-Wisp",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_winter-wolf",
            "pack": "monsters",
            "compendiumId": "yGTh874etxUckmAf",
            "name": "Winter Wolf",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_wolf",
            "pack": "monsters",
            "compendiumId": "yawTeS8u2FCfzzZH",
            "name": "Wolf",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_worg",
            "pack": "monsters",
            "compendiumId": "VBkp2rGQKvMcCOus",
            "name": "Worg",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_wraith",
            "pack": "monsters",
            "compendiumId": "ET4PEVEiNJLU4f7c",
            "name": "Wraith",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_wyvern",
            "pack": "monsters",
            "compendiumId": "7198siHjPJf8g0cG",
            "name": "Wyvern",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_xorn",
            "pack": "monsters",
            "compendiumId": "2MZNHeOZweXAYbv1",
            "name": "Xorn",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-black-dragon",
            "pack": "monsters",
            "compendiumId": "bcapsJdIhY5WktpT",
            "name": "Young Black Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-blue-dragon",
            "pack": "monsters",
            "compendiumId": "mNijwXPMhwR7yYfc",
            "name": "Young Blue Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-brass-dragon",
            "pack": "monsters",
            "compendiumId": "FzvZ6xl3U9GoL9ju",
            "name": "Young Brass Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-bronze-dragon",
            "pack": "monsters",
            "compendiumId": "NmQLj0zv4FmfuSan",
            "name": "Young Bronze Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-copper-dragon",
            "pack": "monsters",
            "compendiumId": "qW8cBwg7ghCA4Cw6",
            "name": "Young Copper Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-gold-dragon",
            "pack": "monsters",
            "compendiumId": "QSytPah5WKoFJ1zt",
            "name": "Young Gold Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-green-dragon",
            "pack": "monsters",
            "compendiumId": "85ahD1jEo9B3POaQ",
            "name": "Young Green Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-red-dragon",
            "pack": "monsters",
            "compendiumId": "qrasJNDC7SGj7xzG",
            "name": "Young Red Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-silver-dragon",
            "pack": "monsters",
            "compendiumId": "eykRfV85DQJoCkmc",
            "name": "Young Silver Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_young-white-dragon",
            "pack": "monsters",
            "compendiumId": "u1UQfHutP5eEKkjM",
            "name": "Young White Dragon",
            "match": "exact"
        },
        {
            "kind": "creature",
            "upstreamKey": "srd_zombie",
            "pack": "monsters",
            "compendiumId": "NAISFPoNNgUCsEyW",
            "name": "Zombie",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "spell/srd_shield",
            "pack": "spells",
            "compendiumId": "z1mx84ONwkXKUZd7",
            "name": "Shield",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_acid-arrow",
            "pack": "spells",
            "compendiumId": "4H6YgYdKgnX6ZQ8M",
            "name": "Acid Arrow",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_acid-splash",
            "pack": "spells",
            "compendiumId": "JLTQyqXEaJDrTXyW",
            "name": "Acid Splash",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_aid",
            "pack": "spells",
            "compendiumId": "Opwh2PdX4runSBlm",
            "name": "Aid",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_alarm",
            "pack": "spells",
            "compendiumId": "7p9IuWrSWFgfyQo2",
            "name": "Alarm",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_alter-self",
            "pack": "spells",
            "compendiumId": "8RTDOt80u8aBv9qx",
            "name": "Alter Self",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_animal-friendship",
            "pack": "spells",
            "compendiumId": "hDOENzjuj5WpLq7B",
            "name": "Animal Friendship",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_animal-messenger",
            "pack": "spells",
            "compendiumId": "X8w9EzYLGc4vQ1H2",
            "name": "Animal Messenger",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_animal-shapes",
            "pack": "spells",
            "compendiumId": "ohqAIBg6de989CIo",
            "name": "Animal Shapes",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_animate-dead",
            "pack": "spells",
            "compendiumId": "oyE5nVppa5mde5gT",
            "name": "Animate Dead",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_animate-objects",
            "pack": "spells",
            "compendiumId": "ATo0Eb63TDtnu6iA",
            "name": "Animate Objects",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_antilife-shell",
            "pack": "spells",
            "compendiumId": "wXzkqpeFP8eWgJzK",
            "name": "Antilife Shell",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_antimagic-field",
            "pack": "spells",
            "compendiumId": "Eon0jzGzQRNluTPQ",
            "name": "Antimagic Field",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_antipathysympathy",
            "pack": "spells",
            "compendiumId": "GJ2WYm3SQFR0winH",
            "name": "Antipathy/Sympathy",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_arcane-eye",
            "pack": "spells",
            "compendiumId": "ImlCJQwR1VL40Qem",
            "name": "Arcane Eye",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_arcane-hand",
            "pack": "spells",
            "compendiumId": "a2KJHCIbY5Mi4Dmn",
            "name": "Arcane Hand",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_arcane-lock",
            "pack": "spells",
            "compendiumId": "8cse7rit0oswRPUP",
            "name": "Arcane Lock",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_arcane-sword",
            "pack": "spells",
            "compendiumId": "LTDNWoFVJNLjiiNa",
            "name": "Arcane Sword",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_arcanists-magic-aura",
            "pack": "spells",
            "compendiumId": "RvEqsD89Zvd5yex4",
            "name": "Arcanist's Magic Aura",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_astral-projection",
            "pack": "spells",
            "compendiumId": "TIoadMIsUKD4edXi",
            "name": "Astral Projection",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_augury",
            "pack": "spells",
            "compendiumId": "4v2H3hHb3Ph9XLNd",
            "name": "Augury",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_awaken",
            "pack": "spells",
            "compendiumId": "MCEpGpvovcXagwQS",
            "name": "Awaken",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_bane",
            "pack": "spells",
            "compendiumId": "95K2aUhAGV9qXjnf",
            "name": "Bane",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_banishment",
            "pack": "spells",
            "compendiumId": "pxpb2eOB6bv4phAf",
            "name": "Banishment",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_barkskin",
            "pack": "spells",
            "compendiumId": "JPwIEfgUPVebr5AH",
            "name": "Barkskin",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_beacon-of-hope",
            "pack": "spells",
            "compendiumId": "ZU9d6woBdUP8pIPt",
            "name": "Beacon of Hope",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_bestow-curse",
            "pack": "spells",
            "compendiumId": "pO4zGe5LmFIYqJiL",
            "name": "Bestow Curse",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_black-tentacles",
            "pack": "spells",
            "compendiumId": "DGONTFbk5eORs5qv",
            "name": "Black Tentacles",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_blade-barrier",
            "pack": "spells",
            "compendiumId": "dLJhxDfeyOsc3zsY",
            "name": "Blade Barrier",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_bless",
            "pack": "spells",
            "compendiumId": "8dzaICjGy6mTUaUr",
            "name": "Bless",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_blight",
            "pack": "spells",
            "compendiumId": "pybg5MNc3lkerH4Y",
            "name": "Blight",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_blindnessdeafness",
            "pack": "spells",
            "compendiumId": "zwGsAv6kmwzYGhh3",
            "name": "Blindness/Deafness",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_blink",
            "pack": "spells",
            "compendiumId": "GSvLWcdCZLQkilXT",
            "name": "Blink",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_blur",
            "pack": "spells",
            "compendiumId": "UDUnlfPsOAbq2RSE",
            "name": "Blur",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_branding-smite",
            "pack": "spells",
            "compendiumId": "7UwUjJ6owIQkEPrs",
            "name": "Branding Smite",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_burning-hands",
            "pack": "spells",
            "compendiumId": "5SuJewoa1CRWaj1F",
            "name": "Burning Hands",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_call-lightning",
            "pack": "spells",
            "compendiumId": "ehvmg9U9fcMEhE4z",
            "name": "Call Lightning",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_calm-emotions",
            "pack": "spells",
            "compendiumId": "3MYDjS6k9IYL0aTj",
            "name": "Calm Emotions",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_chain-lightning",
            "pack": "spells",
            "compendiumId": "QbTxN5dWIbYZ4jLU",
            "name": "Chain Lightning",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_charm-person",
            "pack": "spells",
            "compendiumId": "eS7XnnApoxRxYXPs",
            "name": "Charm Person",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_chill-touch",
            "pack": "spells",
            "compendiumId": "vrN18tbTw7io5MWd",
            "name": "Chill Touch",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_circle-of-death",
            "pack": "spells",
            "compendiumId": "KeunEkg1JYbOCOhV",
            "name": "Circle of Death",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_clairvoyance",
            "pack": "spells",
            "compendiumId": "cg50KpBkBdPK6vPL",
            "name": "Clairvoyance",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_clone",
            "pack": "spells",
            "compendiumId": "h830iyqParFleNqR",
            "name": "Clone",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_cloudkill",
            "pack": "spells",
            "compendiumId": "LkvI11Uue774QBKZ",
            "name": "Cloudkill",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_color-spray",
            "pack": "spells",
            "compendiumId": "LWTUqKkUQdMAmOe0",
            "name": "Color Spray",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_command",
            "pack": "spells",
            "compendiumId": "arzCrMRgcNiQuh43",
            "name": "Command",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_commune",
            "pack": "spells",
            "compendiumId": "d54VDyFulD9xxY7J",
            "name": "Commune",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_commune-with-nature",
            "pack": "spells",
            "compendiumId": "dp6xny4v8PDoIGjh",
            "name": "Commune with Nature",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_comprehend-languages",
            "pack": "spells",
            "compendiumId": "4dSvfvTy2ZIJ3K4k",
            "name": "Comprehend Languages",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_compulsion",
            "pack": "spells",
            "compendiumId": "P6f1PPKPd9BCb742",
            "name": "Compulsion",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_cone-of-cold",
            "pack": "spells",
            "compendiumId": "RpKjTlYASrfqUPVA",
            "name": "Cone of Cold",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_confusion",
            "pack": "spells",
            "compendiumId": "9hQXdMSmerkTsHDe",
            "name": "Confusion",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_conjure-animals",
            "pack": "spells",
            "compendiumId": "1Drt0SHxbEAHxprN",
            "name": "Conjure Animals",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_conjure-celestial",
            "pack": "spells",
            "compendiumId": "XT7nzJmVGgv73uaf",
            "name": "Conjure Celestial",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_conjure-elemental",
            "pack": "spells",
            "compendiumId": "1LkZvINag7KqBmDR",
            "name": "Conjure Elemental",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_conjure-fey",
            "pack": "spells",
            "compendiumId": "yN3XZZujhR4aVvPa",
            "name": "Conjure Fey",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_conjure-minor-elementals",
            "pack": "spells",
            "compendiumId": "KgEw3sDr39C6g8nY",
            "name": "Conjure Minor Elementals",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_conjure-woodland-beings",
            "pack": "spells",
            "compendiumId": "dEfSELiY1eO3cpX9",
            "name": "Conjure Woodland Beings",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_contact-other-plane",
            "pack": "spells",
            "compendiumId": "dSTu1MaPhBqPITwM",
            "name": "Contact Other Plane",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_contagion",
            "pack": "spells",
            "compendiumId": "CjIq8Ed7bu3vVwT1",
            "name": "Contagion",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_contingency",
            "pack": "spells",
            "compendiumId": "4smlOvpF5AQHcyg1",
            "name": "Contingency",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_continual-flame",
            "pack": "spells",
            "compendiumId": "MK6gpQMeDFo0cP9f",
            "name": "Continual Flame",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_control-water",
            "pack": "spells",
            "compendiumId": "7fFHlBk3UNX8gPKL",
            "name": "Control Water",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_control-weather",
            "pack": "spells",
            "compendiumId": "ZPd73HtKF3At11jh",
            "name": "Control Weather",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_counterspell",
            "pack": "spells",
            "compendiumId": "Ek45cBpVXvJdv1Qy",
            "name": "Counterspell",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_create-food-and-water",
            "pack": "spells",
            "compendiumId": "BV0mpbHh29IbbIj5",
            "name": "Create Food and Water",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_create-or-destroy-water",
            "pack": "spells",
            "compendiumId": "a3XtAO5n2GrqiAh5",
            "name": "Create or Destroy Water",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_create-undead",
            "pack": "spells",
            "compendiumId": "E4NXux0RHvME1XgP",
            "name": "Create Undead",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_creation",
            "pack": "spells",
            "compendiumId": "lnaGnxMzpYnbw1uU",
            "name": "Creation",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_cure-wounds",
            "pack": "spells",
            "compendiumId": "uUWb1wZgtMou0TVP",
            "name": "Cure Wounds",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_dancing-lights",
            "pack": "spells",
            "compendiumId": "CAxSzHWizrafT033",
            "name": "Dancing Lights",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_darkness",
            "pack": "spells",
            "compendiumId": "S7VbUetIfVT7B6Eq",
            "name": "Darkness",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_darkvision",
            "pack": "spells",
            "compendiumId": "hJ6ZiA3fpoY8v9cp",
            "name": "Darkvision",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_daylight",
            "pack": "spells",
            "compendiumId": "BP3GCwa66IAw1yTG",
            "name": "Daylight",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_death-ward",
            "pack": "spells",
            "compendiumId": "VtCXMdyM6mAdIJZb",
            "name": "Death Ward",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_delayed-blast-fireball",
            "pack": "spells",
            "compendiumId": "AoTTjapz1FsGOIZz",
            "name": "Delayed Blast Fireball",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_demiplane",
            "pack": "spells",
            "compendiumId": "xNM9CzQQr2CieM4B",
            "name": "Demiplane",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_detect-evil-and-good",
            "pack": "spells",
            "compendiumId": "Mzh95utKDPIrjiH8",
            "name": "Detect Evil and Good",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_detect-magic",
            "pack": "spells",
            "compendiumId": "ghXTfe7sgCbgf1Q8",
            "name": "Detect Magic",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_detect-poison-and-disease",
            "pack": "spells",
            "compendiumId": "2skfDtglk1mGrb3l",
            "name": "Detect Poison and Disease",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_detect-thoughts",
            "pack": "spells",
            "compendiumId": "ppWAAEul0QHtm4er",
            "name": "Detect Thoughts",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_dimension-door",
            "pack": "spells",
            "compendiumId": "A4RsPuSvB9wFtz1j",
            "name": "Dimension Door",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_disguise-self",
            "pack": "spells",
            "compendiumId": "A3q2gTNqG6fvNGrv",
            "name": "Disguise Self",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_disintegrate",
            "pack": "spells",
            "compendiumId": "HBHbOGKNVVprSlwn",
            "name": "Disintegrate",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_dispel-evil-and-good",
            "pack": "spells",
            "compendiumId": "TkJ8Wtg1L7TZtspm",
            "name": "Dispel Evil and Good",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_dispel-magic",
            "pack": "spells",
            "compendiumId": "15Fa6q1nH27XfbR8",
            "name": "Dispel Magic",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_divination",
            "pack": "spells",
            "compendiumId": "XqzXSKNR75ZdYTA9",
            "name": "Divination",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_divine-favor",
            "pack": "spells",
            "compendiumId": "8MICCMeOXT3aJUy9",
            "name": "Divine Favor",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_divine-word",
            "pack": "spells",
            "compendiumId": "T1vpZLam7LezjToj",
            "name": "Divine Word",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_dominate-beast",
            "pack": "spells",
            "compendiumId": "LrPvWHBPmiMQQsKB",
            "name": "Dominate Beast",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_dominate-monster",
            "pack": "spells",
            "compendiumId": "eEpy1ONlXumKS1mp",
            "name": "Dominate Monster",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_dominate-person",
            "pack": "spells",
            "compendiumId": "91Sw6vOIaO7U8DvM",
            "name": "Dominate Person",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_dream",
            "pack": "spells",
            "compendiumId": "kSPRpeIx3w3nihrF",
            "name": "Dream",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_druidcraft",
            "pack": "spells",
            "compendiumId": "SbSvZKkJASyk8jKo",
            "name": "Druidcraft",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_earthquake",
            "pack": "spells",
            "compendiumId": "x5JNBSyIBBZsjcGT",
            "name": "Earthquake",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_eldritch-blast",
            "pack": "spells",
            "compendiumId": "Z9p1vezIn95jw1Yw",
            "name": "Eldritch Blast",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_enhance-ability",
            "pack": "spells",
            "compendiumId": "9eOZDBImVKxbeOyZ",
            "name": "Enhance Ability",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_enlargereduce",
            "pack": "spells",
            "compendiumId": "WahI41a3goVUg0x1",
            "name": "Enlarge/Reduce",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_entangle",
            "pack": "spells",
            "compendiumId": "gMrWeG8fMDPRFiVe",
            "name": "Entangle",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_enthrall",
            "pack": "spells",
            "compendiumId": "30ZgXtijJVCxQk5N",
            "name": "Enthrall",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_etherealness",
            "pack": "spells",
            "compendiumId": "PQuEgKyCdovOvhqN",
            "name": "Etherealness",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_expeditious-retreat",
            "pack": "spells",
            "compendiumId": "zPGohqJRir6MyQ3U",
            "name": "Expeditious Retreat",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_eyebite",
            "pack": "spells",
            "compendiumId": "ZRqu3Xh9FmlBCZGy",
            "name": "Eyebite",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_fabricate",
            "pack": "spells",
            "compendiumId": "7Fw7Bf1k3xxDVr5L",
            "name": "Fabricate",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_faerie-fire",
            "pack": "spells",
            "compendiumId": "nqBDWkVOfcGZt4YU",
            "name": "Faerie Fire",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_faithful-hound",
            "pack": "spells",
            "compendiumId": "SAj03P2WBDiWu7zu",
            "name": "Faithful Hound",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_false-life",
            "pack": "spells",
            "compendiumId": "7e3QXF10hLNDEdr6",
            "name": "False Life",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_fear",
            "pack": "spells",
            "compendiumId": "XXUDGFELgoskdOD0",
            "name": "Fear",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_feather-fall",
            "pack": "spells",
            "compendiumId": "pub0OWVEB71XQx1n",
            "name": "Feather Fall",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_feeblemind",
            "pack": "spells",
            "compendiumId": "hYCrN82dMJFuJODB",
            "name": "Feeblemind",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_find-familiar",
            "pack": "spells",
            "compendiumId": "JGT5bNqu9REL7Fuz",
            "name": "Find Familiar",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_find-steed",
            "pack": "spells",
            "compendiumId": "5eh2HFbS13078Y3H",
            "name": "Find Steed",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_find-the-path",
            "pack": "spells",
            "compendiumId": "cYI4RNNjI5GAmLhy",
            "name": "Find the Path",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_find-traps",
            "pack": "spells",
            "compendiumId": "KrM3oHVv13RAALrS",
            "name": "Find Traps",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_finger-of-death",
            "pack": "spells",
            "compendiumId": "HPvZm8YJO91k6Qdg",
            "name": "Finger of Death",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_fire-bolt",
            "pack": "spells",
            "compendiumId": "EOmsUcFQJTfG2oio",
            "name": "Fire Bolt",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_fire-shield",
            "pack": "spells",
            "compendiumId": "avD5XUtkBPQQR97c",
            "name": "Fire Shield",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_fire-storm",
            "pack": "spells",
            "compendiumId": "J3uILDYS7MiOfmTJ",
            "name": "Fire Storm",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_fireball",
            "pack": "spells",
            "compendiumId": "ztgcdrWPshKRpFd0",
            "name": "Fireball",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_flame-blade",
            "pack": "spells",
            "compendiumId": "Advtckpz1B733bu9",
            "name": "Flame Blade",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_flame-strike",
            "pack": "spells",
            "compendiumId": "5e1xTohkzqFqbYH4",
            "name": "Flame Strike",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_flaming-sphere",
            "pack": "spells",
            "compendiumId": "FjYE214HTERCRZNm",
            "name": "Flaming Sphere",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_flesh-to-stone",
            "pack": "spells",
            "compendiumId": "kozNy29b0X6exFhY",
            "name": "Flesh to Stone",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_floating-disk",
            "pack": "spells",
            "compendiumId": "bnjXlk13ZRJuf5d0",
            "name": "Floating Disk",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_fly",
            "pack": "spells",
            "compendiumId": "yfbK8gZqESlaoY5t",
            "name": "Fly",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_fog-cloud",
            "pack": "spells",
            "compendiumId": "IBJmWjzbQGu7M4UX",
            "name": "Fog Cloud",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_forbiddance",
            "pack": "spells",
            "compendiumId": "64D1gNZ4hx7SWG2x",
            "name": "Forbiddance",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_forcecage",
            "pack": "spells",
            "compendiumId": "Y7uWUO4yqUN0JKl0",
            "name": "Forcecage",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_foresight",
            "pack": "spells",
            "compendiumId": "6HEEhLdJz32TL4Js",
            "name": "Foresight",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_freedom-of-movement",
            "pack": "spells",
            "compendiumId": "da0a1t2FqaTjRZGT",
            "name": "Freedom of Movement",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_freezing-sphere",
            "pack": "spells",
            "compendiumId": "MImfWCzEPRMYD3Xp",
            "name": "Freezing Sphere",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_gaseous-form",
            "pack": "spells",
            "compendiumId": "2IWiZAJtOGDoKjiz",
            "name": "Gaseous Form",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_gate",
            "pack": "spells",
            "compendiumId": "XbwGq5kDJNvAxNXV",
            "name": "Gate",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_geas",
            "pack": "spells",
            "compendiumId": "JQyigMNPiDnGI18b",
            "name": "Geas",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_gentle-repose",
            "pack": "spells",
            "compendiumId": "n4JDcFKe5ikzYmAc",
            "name": "Gentle Repose",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_giant-insect",
            "pack": "spells",
            "compendiumId": "czXrVRx6XYRWsHAi",
            "name": "Giant Insect",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_glibness",
            "pack": "spells",
            "compendiumId": "1RzxKZzkQOoioxPj",
            "name": "Glibness",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_globe-of-invulnerability",
            "pack": "spells",
            "compendiumId": "WmQpxfjZwF3MGUby",
            "name": "Globe of Invulnerability",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_glyph-of-warding",
            "pack": "spells",
            "compendiumId": "pB7XVYwdGNcUG935",
            "name": "Glyph of Warding",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_goodberry",
            "pack": "spells",
            "compendiumId": "Qf6CAZkc7ms4ZY3e",
            "name": "Goodberry",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_grease",
            "pack": "spells",
            "compendiumId": "etgcR9wqmrhyZ0tx",
            "name": "Grease",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_greater-invisibility",
            "pack": "spells",
            "compendiumId": "tEpDmYZNGc9f5OhJ",
            "name": "Greater Invisibility",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_greater-restoration",
            "pack": "spells",
            "compendiumId": "WzvJ7G3cqvIubsLk",
            "name": "Greater Restoration",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_guardian-of-faith",
            "pack": "spells",
            "compendiumId": "TgHsuhNasPbhu8MO",
            "name": "Guardian of Faith",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_guards-and-wards",
            "pack": "spells",
            "compendiumId": "yw0tYQkOMCgKZ8Ur",
            "name": "Guards and Wards",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_guidance",
            "pack": "spells",
            "compendiumId": "P7mF2MxSuVJwHRRY",
            "name": "Guidance",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_guiding-bolt",
            "pack": "spells",
            "compendiumId": "7buEm5KhI5lP8m1z",
            "name": "Guiding Bolt",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_gust-of-wind",
            "pack": "spells",
            "compendiumId": "FSMy6VAjDnXY9vWz",
            "name": "Gust of Wind",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_hallow",
            "pack": "spells",
            "compendiumId": "SLxA9QhrggTz0taU",
            "name": "Hallow",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_hallucinatory-terrain",
            "pack": "spells",
            "compendiumId": "sTIkQK7KuQNOyY0C",
            "name": "Hallucinatory Terrain",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_harm",
            "pack": "spells",
            "compendiumId": "tMH6Ivn4GmE1naMj",
            "name": "Harm",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_haste",
            "pack": "spells",
            "compendiumId": "Szvk5FEVQW3uhJi5",
            "name": "Haste",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_heal",
            "pack": "spells",
            "compendiumId": "qcYitWoSMTnKkzM1",
            "name": "Heal",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_healing-word",
            "pack": "spells",
            "compendiumId": "o8Dh7fblk1d16tnO",
            "name": "Healing Word",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_heat-metal",
            "pack": "spells",
            "compendiumId": "2yHXEcrRbadZDr5M",
            "name": "Heat Metal",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_hellish-rebuke",
            "pack": "spells",
            "compendiumId": "22dPoeXfaaAv4K3h",
            "name": "Hellish Rebuke",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_heroes-feast",
            "pack": "spells",
            "compendiumId": "mgFqi0ev8f7Ut19y",
            "name": "Heroes' Feast",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_heroism",
            "pack": "spells",
            "compendiumId": "ge3Saet9zPTDyaoL",
            "name": "Heroism",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_hideous-laughter",
            "pack": "spells",
            "compendiumId": "BQk5Row4NymMnUQl",
            "name": "Hideous Laughter",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_hold-monster",
            "pack": "spells",
            "compendiumId": "l9Ju5KE7bbn3WpTm",
            "name": "Hold Monster",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_hold-person",
            "pack": "spells",
            "compendiumId": "3Lo9boi7P2ro6QV4",
            "name": "Hold Person",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_holy-aura",
            "pack": "spells",
            "compendiumId": "j8S49Rea8b1640Zi",
            "name": "Holy Aura",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_hunters-mark",
            "pack": "spells",
            "compendiumId": "0xmXiPiuYws1OGcX",
            "name": "Hunter's Mark",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_hypnotic-pattern",
            "pack": "spells",
            "compendiumId": "6g3WLOZ2u0EbaLAd",
            "name": "Hypnotic Pattern",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_ice-storm",
            "pack": "spells",
            "compendiumId": "WN2LWEljYU6QqnRH",
            "name": "Ice Storm",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_identify",
            "pack": "spells",
            "compendiumId": "3OZnNhunvRtPOQmH",
            "name": "Identify",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_illusory-script",
            "pack": "spells",
            "compendiumId": "82jM6qD9axLJsTrH",
            "name": "Illusory Script",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_imprisonment",
            "pack": "spells",
            "compendiumId": "ZVnL9L8v1KC9TBF4",
            "name": "Imprisonment",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_incendiary-cloud",
            "pack": "spells",
            "compendiumId": "pV04y1iXoWiom6bp",
            "name": "Incendiary Cloud",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_inflict-wounds",
            "pack": "spells",
            "compendiumId": "ksaaTxIbKx2sJfia",
            "name": "Inflict Wounds",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_insect-plague",
            "pack": "spells",
            "compendiumId": "OVikYmSdHliAG2YD",
            "name": "Insect Plague",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_instant-summons",
            "pack": "spells",
            "compendiumId": "SgrEKiC6dAtvy6Pz",
            "name": "Instant Summons",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_invisibility",
            "pack": "spells",
            "compendiumId": "1N8dDMMgZ1h1YJ3B",
            "name": "Invisibility",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_irresistible-dance",
            "pack": "spells",
            "compendiumId": "TfRzwEgBHHkCc6Ql",
            "name": "Irresistible Dance",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_jump",
            "pack": "spells",
            "compendiumId": "ZrTc23tToJ0JpH2h",
            "name": "Jump",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_knock",
            "pack": "spells",
            "compendiumId": "1nhIxh0DsJsntCfj",
            "name": "Knock",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_legend-lore",
            "pack": "spells",
            "compendiumId": "W4Qx5z0id6da0vqg",
            "name": "Legend Lore",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_lesser-restoration",
            "pack": "spells",
            "compendiumId": "F0GsG0SJzsIOacwV",
            "name": "Lesser Restoration",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_levitate",
            "pack": "spells",
            "compendiumId": "MRxldJd6C4bsBo3O",
            "name": "Levitate",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_light",
            "pack": "spells",
            "compendiumId": "Bnn9Nzajixvow9xi",
            "name": "Light",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_lightning-bolt",
            "pack": "spells",
            "compendiumId": "IyikgTEOTv701jgQ",
            "name": "Lightning Bolt",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_locate-animals-or-plants",
            "pack": "spells",
            "compendiumId": "Iv2qqSAT7OkXKPFx",
            "name": "Locate Animals or Plants",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_locate-creature",
            "pack": "spells",
            "compendiumId": "gXtzz9t1DTzJeLr4",
            "name": "Locate Creature",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_locate-object",
            "pack": "spells",
            "compendiumId": "SleYkHovQ8NagmeV",
            "name": "Locate Object",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_longstrider",
            "pack": "spells",
            "compendiumId": "B0pnIcc52O6G8hi8",
            "name": "Longstrider",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mage-armor",
            "pack": "spells",
            "compendiumId": "CKZTpZlxj7hjjo2H",
            "name": "Mage Armor",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mage-hand",
            "pack": "spells",
            "compendiumId": "Utk1OQRwYkMkFRD3",
            "name": "Mage Hand",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_magic-circle",
            "pack": "spells",
            "compendiumId": "y8A4HfTwd93ypdEz",
            "name": "Magic Circle",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_magic-jar",
            "pack": "spells",
            "compendiumId": "ej6wyY4G1gOcb1U6",
            "name": "Magic Jar",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_magic-missile",
            "pack": "spells",
            "compendiumId": "41JIhpDyM9Anm7cs",
            "name": "Magic Missile",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_magic-mouth",
            "pack": "spells",
            "compendiumId": "7v06rdmUakoTk1LQ",
            "name": "Magic Mouth",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_magic-weapon",
            "pack": "spells",
            "compendiumId": "Sgjrf8qqv97CCWM4",
            "name": "Magic Weapon",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_magnificent-mansion",
            "pack": "spells",
            "compendiumId": "pn4SnsFDvYDiE6rC",
            "name": "Magnificent Mansion",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_major-image",
            "pack": "spells",
            "compendiumId": "nslx2nT3p4lNkmdp",
            "name": "Major Image",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mass-cure-wounds",
            "pack": "spells",
            "compendiumId": "Pyzmm8R7rVsNAPsd",
            "name": "Mass Cure Wounds",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mass-heal",
            "pack": "spells",
            "compendiumId": "Y6oItIuhOJZ0i0FC",
            "name": "Mass Heal",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mass-healing-word",
            "pack": "spells",
            "compendiumId": "34ddoYIrnOZ2GFYi",
            "name": "Mass Healing Word",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mass-suggestion",
            "pack": "spells",
            "compendiumId": "5OGFdJw35QXp6mh6",
            "name": "Mass Suggestion",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_maze",
            "pack": "spells",
            "compendiumId": "clwv2PWOcT822hlr",
            "name": "Maze",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_meld-into-stone",
            "pack": "spells",
            "compendiumId": "64uo4fHriHLjRUrX",
            "name": "Meld into Stone",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mending",
            "pack": "spells",
            "compendiumId": "kjmjY0zlE6IEiQVL",
            "name": "Mending",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_message",
            "pack": "spells",
            "compendiumId": "icZokbgV1jIMpNCv",
            "name": "Message",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_meteor-swarm",
            "pack": "spells",
            "compendiumId": "mF52ldF79Cr7wfQo",
            "name": "Meteor Swarm",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mind-blank",
            "pack": "spells",
            "compendiumId": "bllEWfm9xfEKynhv",
            "name": "Mind Blank",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_minor-illusion",
            "pack": "spells",
            "compendiumId": "oIzA2MEHwxhtQneU",
            "name": "Minor Illusion",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mirage-arcane",
            "pack": "spells",
            "compendiumId": "f38w5rd9SgdmWc6F",
            "name": "Mirage Arcane",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mirror-image",
            "pack": "spells",
            "compendiumId": "X4c8xCkmF8U9HUMz",
            "name": "Mirror Image",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_mislead",
            "pack": "spells",
            "compendiumId": "MBMaQLwoy05qzMJ3",
            "name": "Mislead",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_misty-step",
            "pack": "spells",
            "compendiumId": "wqfAVANuQonNBgnL",
            "name": "Misty Step",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_modify-memory",
            "pack": "spells",
            "compendiumId": "r3243JU4AyQJyfX4",
            "name": "Modify Memory",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_moonbeam",
            "pack": "spells",
            "compendiumId": "bV3yun6MIuFj71Er",
            "name": "Moonbeam",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_move-earth",
            "pack": "spells",
            "compendiumId": "yI0XWIgI0IGGsR3R",
            "name": "Move Earth",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_nondetection",
            "pack": "spells",
            "compendiumId": "aU62xVUBYkAQWIHv",
            "name": "Nondetection",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_pass-without-trace",
            "pack": "spells",
            "compendiumId": "pRMvmknwLf2tdMTj",
            "name": "Pass without Trace",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_passwall",
            "pack": "spells",
            "compendiumId": "d9MwcXi7Il3HROXd",
            "name": "Passwall",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_phantasmal-killer",
            "pack": "spells",
            "compendiumId": "BYNvBJzHcF5VJhXw",
            "name": "Phantasmal Killer",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_phantom-steed",
            "pack": "spells",
            "compendiumId": "wpx42mtoZ5BmXRs1",
            "name": "Phantom Steed",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_planar-ally",
            "pack": "spells",
            "compendiumId": "fkREcytuZ8sngWtC",
            "name": "Planar Ally",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_planar-binding",
            "pack": "spells",
            "compendiumId": "42O2aNBW7vK90gTL",
            "name": "Planar Binding",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_plane-shift",
            "pack": "spells",
            "compendiumId": "J6Jpw5XzB5aTeqnz",
            "name": "Plane Shift",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_plant-growth",
            "pack": "spells",
            "compendiumId": "YWtwzp6ZnQJMEmVW",
            "name": "Plant Growth",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_poison-spray",
            "pack": "spells",
            "compendiumId": "g2u9PYfqWQAyg9OI",
            "name": "Poison Spray",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_polymorph",
            "pack": "spells",
            "compendiumId": "04nMsTWkIFvkbXlY",
            "name": "Polymorph",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_power-word-kill",
            "pack": "spells",
            "compendiumId": "dmvaMLFWFtv0qx0S",
            "name": "Power Word Kill",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_power-word-stun",
            "pack": "spells",
            "compendiumId": "35j2QIMmIk6aEdxj",
            "name": "Power Word Stun",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_prayer-of-healing",
            "pack": "spells",
            "compendiumId": "MOEmz9N0j0QPkKEE",
            "name": "Prayer of Healing",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_prestidigitation",
            "pack": "spells",
            "compendiumId": "udsLtG0BugXHR2JQ",
            "name": "Prestidigitation",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_prismatic-spray",
            "pack": "spells",
            "compendiumId": "eGMhwmuleAM46C6L",
            "name": "Prismatic Spray",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_prismatic-wall",
            "pack": "spells",
            "compendiumId": "jmfu8zj4zjjzUbeh",
            "name": "Prismatic Wall",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_private-sanctum",
            "pack": "spells",
            "compendiumId": "NJgxf7pmSsBArIG7",
            "name": "Private Sanctum",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_produce-flame",
            "pack": "spells",
            "compendiumId": "eCPQuQkIabFKTl9u",
            "name": "Produce Flame",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_programmed-illusion",
            "pack": "spells",
            "compendiumId": "bA2sk9eMKBeY7EPD",
            "name": "Programmed Illusion",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_project-image",
            "pack": "spells",
            "compendiumId": "ePhRKHXRE7l1sEoQ",
            "name": "Project Image",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_protection-from-energy",
            "pack": "spells",
            "compendiumId": "j8NtLXOOJ3GAKF8I",
            "name": "Protection from Energy",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_protection-from-evil-and-good",
            "pack": "spells",
            "compendiumId": "xmDBqZhRVrtLP8h2",
            "name": "Protection from Evil and Good",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_protection-from-poison",
            "pack": "spells",
            "compendiumId": "MAxM77CDUu8dgIRQ",
            "name": "Protection from Poison",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_purify-food-and-drink",
            "pack": "spells",
            "compendiumId": "Kn7K5PtYUJAKZTTp",
            "name": "Purify Food and Drink",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_raise-dead",
            "pack": "spells",
            "compendiumId": "AGFMPAmuzwWO6Dfz",
            "name": "Raise Dead",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_ray-of-enfeeblement",
            "pack": "spells",
            "compendiumId": "ODhLKBxLnvvLOnw1",
            "name": "Ray of Enfeeblement",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_ray-of-frost",
            "pack": "spells",
            "compendiumId": "ctW81uiX56xZR2c5",
            "name": "Ray of Frost",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_regenerate",
            "pack": "spells",
            "compendiumId": "9kGrFXnLiRg3Xnbo",
            "name": "Regenerate",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_reincarnate",
            "pack": "spells",
            "compendiumId": "zMEo5DKK8uxsuWnq",
            "name": "Reincarnate",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_remove-curse",
            "pack": "spells",
            "compendiumId": "XZhdgVK3cLoxNCQl",
            "name": "Remove Curse",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_resilient-sphere",
            "pack": "spells",
            "compendiumId": "1ADstb0Xec6HHRcU",
            "name": "Resilient Sphere",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_resistance",
            "pack": "spells",
            "compendiumId": "dl8YwvMboBqX2OC4",
            "name": "Resistance",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_resurrection",
            "pack": "spells",
            "compendiumId": "jhhT9PsHy5A7EojO",
            "name": "Resurrection",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_reverse-gravity",
            "pack": "spells",
            "compendiumId": "ERCv7yuRkQ0YjGx6",
            "name": "Reverse Gravity",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_revivify",
            "pack": "spells",
            "compendiumId": "LmRHHMtplpxr9fX6",
            "name": "Revivify",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_rope-trick",
            "pack": "spells",
            "compendiumId": "ap4dmtshjEbwU3Ts",
            "name": "Rope Trick",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_sacred-flame",
            "pack": "spells",
            "compendiumId": "n9pJzTDsAwQxJVRl",
            "name": "Sacred Flame",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_sanctuary",
            "pack": "spells",
            "compendiumId": "gvdA9nPuWLck4tBl",
            "name": "Sanctuary",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_scorching-ray",
            "pack": "spells",
            "compendiumId": "7u2obDvuvtZBkTfq",
            "name": "Scorching Ray",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_scrying",
            "pack": "spells",
            "compendiumId": "fVbCxFRaORalHB20",
            "name": "Scrying",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_secret-chest",
            "pack": "spells",
            "compendiumId": "8sgwRh8NUNkn9Vi0",
            "name": "Secret Chest",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_see-invisibility",
            "pack": "spells",
            "compendiumId": "DQzlB5Y3k791W5bH",
            "name": "See Invisibility",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_seeming",
            "pack": "spells",
            "compendiumId": "mbFw57uyfLkyiw5k",
            "name": "Seeming",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_sending",
            "pack": "spells",
            "compendiumId": "GtGjNjPBgUHxGYAD",
            "name": "Sending",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_sequester",
            "pack": "spells",
            "compendiumId": "wvLbtemkH8gyBpdc",
            "name": "Sequester",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_shapechange",
            "pack": "spells",
            "compendiumId": "N2UEFq8X5LRsLcOZ",
            "name": "Shapechange",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_shatter",
            "pack": "spells",
            "compendiumId": "wJKpSvSTbSkTjqyb",
            "name": "Shatter",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_shield-of-faith",
            "pack": "spells",
            "compendiumId": "jZ6JNykRtdQ90MOo",
            "name": "Shield of Faith",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_shillelagh",
            "pack": "spells",
            "compendiumId": "VzgFzcmocr1X1cp4",
            "name": "Shillelagh",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_shocking-grasp",
            "pack": "spells",
            "compendiumId": "XvbiNhNqXXIFisIy",
            "name": "Shocking Grasp",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_silence",
            "pack": "spells",
            "compendiumId": "5VhqFROQYjr1P9lp",
            "name": "Silence",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_silent-image",
            "pack": "spells",
            "compendiumId": "BrBZdCCrJRIVg7YX",
            "name": "Silent Image",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_simulacrum",
            "pack": "spells",
            "compendiumId": "jccbeBIfLrqEZnDP",
            "name": "Simulacrum",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_sleep",
            "pack": "spells",
            "compendiumId": "KhwiSi9fwVfUPtku",
            "name": "Sleep",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_sleet-storm",
            "pack": "spells",
            "compendiumId": "dhqBY4TvVjxVmOZd",
            "name": "Sleet Storm",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_slow",
            "pack": "spells",
            "compendiumId": "yqUDoxk4x0NWG5Bz",
            "name": "Slow",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_spare-the-dying",
            "pack": "spells",
            "compendiumId": "8zT7njvqbpXs4Cel",
            "name": "Spare the Dying",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_speak-with-animals",
            "pack": "spells",
            "compendiumId": "aL1F8fvYLtNzUbKu",
            "name": "Speak with Animals",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_speak-with-dead",
            "pack": "spells",
            "compendiumId": "I2LUSF5ogc7Bj62e",
            "name": "Speak with Dead",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_speak-with-plants",
            "pack": "spells",
            "compendiumId": "2VXGS206tuChoeXy",
            "name": "Speak with Plants",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_spider-climb",
            "pack": "spells",
            "compendiumId": "KJRVzeMQXPj8Gtyx",
            "name": "Spider Climb",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_spike-growth",
            "pack": "spells",
            "compendiumId": "9gYGkrL6qFTsE6fw",
            "name": "Spike Growth",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_spirit-guardians",
            "pack": "spells",
            "compendiumId": "uCud2s4TjMfjiXUb",
            "name": "Spirit Guardians",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_spiritual-weapon",
            "pack": "spells",
            "compendiumId": "JbxsYXxSOTZbf9I0",
            "name": "Spiritual Weapon",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_stinking-cloud",
            "pack": "spells",
            "compendiumId": "TwlD4PLcltv7Xh7j",
            "name": "Stinking Cloud",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_stone-shape",
            "pack": "spells",
            "compendiumId": "QvGcdRUSNRKEQJlK",
            "name": "Stone Shape",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_stoneskin",
            "pack": "spells",
            "compendiumId": "ReMbjfeOKoSj3O79",
            "name": "Stoneskin",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_storm-of-vengeance",
            "pack": "spells",
            "compendiumId": "7KjExw0kmuqERa7C",
            "name": "Storm of Vengeance",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_suggestion",
            "pack": "spells",
            "compendiumId": "zMAWdyc8UVb37BK4",
            "name": "Suggestion",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_sunbeam",
            "pack": "spells",
            "compendiumId": "2RC0EyvBLPH88PZF",
            "name": "Sunbeam",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_sunburst",
            "pack": "spells",
            "compendiumId": "hzK7FQya0BDjSmLE",
            "name": "Sunburst",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_symbol",
            "pack": "spells",
            "compendiumId": "B2kbmgbA2WQR00kx",
            "name": "Symbol",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_telekinesis",
            "pack": "spells",
            "compendiumId": "HQfd7jJyULIoGxrZ",
            "name": "Telekinesis",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_telepathic-bond",
            "pack": "spells",
            "compendiumId": "uAwtVZkiSTyP6ORB",
            "name": "Telepathic Bond",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_teleport",
            "pack": "spells",
            "compendiumId": "L4J89JXqbKs6puEV",
            "name": "Teleport",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_teleportation-circle",
            "pack": "spells",
            "compendiumId": "8aWtP5hcrmcEesBW",
            "name": "Teleportation Circle",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_thaumaturgy",
            "pack": "spells",
            "compendiumId": "MUO1uYN7JR1hm4dR",
            "name": "Thaumaturgy",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_thunderwave",
            "pack": "spells",
            "compendiumId": "WTbOQBsarsL1LuXJ",
            "name": "Thunderwave",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_time-stop",
            "pack": "spells",
            "compendiumId": "JYuRBwxpoFhXduvD",
            "name": "Time Stop",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_tiny-hut",
            "pack": "spells",
            "compendiumId": "NXWWWgHtWb7Nv21F",
            "name": "Tiny Hut",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_tongues",
            "pack": "spells",
            "compendiumId": "gopnZvS0c2jD5FP8",
            "name": "Tongues",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_transport-via-plants",
            "pack": "spells",
            "compendiumId": "s7nXgot5gGZVcMrv",
            "name": "Transport via Plants",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_tree-stride",
            "pack": "spells",
            "compendiumId": "DUBgwHPakcLDkB6W",
            "name": "Tree Stride",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_true-polymorph",
            "pack": "spells",
            "compendiumId": "QbQZKoXOgHWN06aa",
            "name": "True Polymorph",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_true-resurrection",
            "pack": "spells",
            "compendiumId": "qLeEXZDbW5y4bmLY",
            "name": "True Resurrection",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_true-seeing",
            "pack": "spells",
            "compendiumId": "XzkJpE6XpZfKjODD",
            "name": "True Seeing",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_true-strike",
            "pack": "spells",
            "compendiumId": "mGGlcLdggHwcL7MG",
            "name": "True Strike",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_unseen-servant",
            "pack": "spells",
            "compendiumId": "ccduLIvutyNqvkgv",
            "name": "Unseen Servant",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_vampiric-touch",
            "pack": "spells",
            "compendiumId": "UfHQhA54M4323gVO",
            "name": "Vampiric Touch",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_vicious-mockery",
            "pack": "spells",
            "compendiumId": "cdrYKaFi98YWaBMw",
            "name": "Vicious Mockery",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_wall-of-fire",
            "pack": "spells",
            "compendiumId": "X3DrXgxjwI2dvkD6",
            "name": "Wall of Fire",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_wall-of-force",
            "pack": "spells",
            "compendiumId": "o9ZCvuD2B1OTcubb",
            "name": "Wall of Force",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_wall-of-ice",
            "pack": "spells",
            "compendiumId": "fzZnVKLmBMo2f5up",
            "name": "Wall of Ice",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_wall-of-stone",
            "pack": "spells",
            "compendiumId": "NmoRmM1mhuM3pqnY",
            "name": "Wall of Stone",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_wall-of-thorns",
            "pack": "spells",
            "compendiumId": "AQsBc94ES7W7s7iG",
            "name": "Wall of Thorns",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_warding-bond",
            "pack": "spells",
            "compendiumId": "JVhKeanAXZH62DrF",
            "name": "Warding Bond",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_water-breathing",
            "pack": "spells",
            "compendiumId": "13uVuBQP6VaiSPvC",
            "name": "Water Breathing",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_water-walk",
            "pack": "spells",
            "compendiumId": "YBda6nLKjxdT1LbS",
            "name": "Water Walk",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_web",
            "pack": "spells",
            "compendiumId": "UJJu9c2UvCzVljiP",
            "name": "Web",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_weird",
            "pack": "spells",
            "compendiumId": "Wl2vtJ4hCt2tpWfR",
            "name": "Weird",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_wind-walk",
            "pack": "spells",
            "compendiumId": "8PJAsHmbu6UgDHC0",
            "name": "Wind Walk",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_wind-wall",
            "pack": "spells",
            "compendiumId": "ew6GA8dJy2spQmFW",
            "name": "Wind Wall",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_wish",
            "pack": "spells",
            "compendiumId": "3okM6Gn63zzEULkz",
            "name": "Wish",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_word-of-recall",
            "pack": "spells",
            "compendiumId": "76C0FdcxlU8F9Rl2",
            "name": "Word of Recall",
            "match": "exact"
        },
        {
            "kind": "spell",
            "upstreamKey": "srd_zone-of-truth",
            "pack": "spells",
            "compendiumId": "CylBa7jR8DSbo8Z3",
            "name": "Zone of Truth",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "item/srd_shield",
            "pack": "items",
            "compendiumId": "sSs3hSzkKBMNBgTs",
            "name": "Shield",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_abacus",
            "pack": "items",
            "compendiumId": "ea4xclqsksEQB1QF",
            "name": "Abacus",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_acid-vial",
            "pack": "items",
            "compendiumId": "Sx5E6utixHdAbGNb",
            "name": "Acid (vial)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_adamantine-armor-breastplate",
            "pack": "items",
            "compendiumId": "DevmObXWP9MfwE2c",
            "name": "Adamantine Breastplate",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_adamantine-armor-chain-mail",
            "pack": "items",
            "compendiumId": "n7fm71CN7qDIBEKk",
            "name": "Adamantine Chain Mail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_adamantine-armor-chain-shirt",
            "pack": "items",
            "compendiumId": "kjTPoUeomTPWJ9h3",
            "name": "Adamantine Chain Shirt",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_adamantine-armor-half-plate",
            "pack": "items",
            "compendiumId": "159agyOuBHCl2WKd",
            "name": "Adamantine Half Plate Armor",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_adamantine-armor-plate",
            "pack": "items",
            "compendiumId": "sP8CV5VNEcY1Yh1Q",
            "name": "Adamantine Plate Armor",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_adamantine-armor-ring-mail",
            "pack": "items",
            "compendiumId": "UpHAWqwifZpiZzns",
            "name": "Adamantine Ring Mail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_adamantine-armor-scale-mail",
            "pack": "items",
            "compendiumId": "LdAj2ES9EzfnWcA1",
            "name": "Adamantine Scale Mail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_adamantine-armor-splint",
            "pack": "items",
            "compendiumId": "LDuqUcosOK8Bf76S",
            "name": "Adamantine Splint Armor",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_alchemists-fire-flask",
            "pack": "items",
            "compendiumId": "FvNOwWbh5FXyX4xe",
            "name": "Alchemist's Fire",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_alchemists-supplies",
            "pack": "items",
            "compendiumId": "SztwZhbhZeCqyAes",
            "name": "Alchemist's Supplies",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_amulet",
            "pack": "items",
            "compendiumId": "paqlMjggWkBIAeCe",
            "name": "Amulet",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_amulet-of-health",
            "pack": "items",
            "compendiumId": "iiQxTvDOhPGW5spF",
            "name": "Amulet of Health",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_amulet-of-proof-against-detection-and-location",
            "pack": "items",
            "compendiumId": "50N8zf58FR4JWR05",
            "name": "Amulet of Proof against Detection and Location",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_amulet-of-the-planes",
            "pack": "items",
            "compendiumId": "8ABk0XV76Hzq8Qul",
            "name": "Amulet of the Planes",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_animated-shield",
            "pack": "items",
            "compendiumId": "NG8BlE2nwYJxCjWO",
            "name": "Animated Shield",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_antitoxin-vial",
            "pack": "items",
            "compendiumId": "Fc6UfFNOnW80XMzi",
            "name": "Antitoxin",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_apparatus-of-the-crab",
            "pack": "items",
            "compendiumId": "lSd5QHnIJbKvP1bh",
            "name": "Apparatus of the Crab",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-invulnerability",
            "pack": "items",
            "compendiumId": "evSCq83oPhR0ZK4y",
            "name": "Armor of Invulnerability",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-breastplate",
            "pack": "items",
            "compendiumId": "lccm5AjIk91aIHbi",
            "name": "Breastplate Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-chain-mail",
            "pack": "items",
            "compendiumId": "BQw5lyopqLmf8B6u",
            "name": "Chain Mail Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-chain-shirt",
            "pack": "items",
            "compendiumId": "HF32aZSVw4P0MR4K",
            "name": "Chain Shirt Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-half-plate",
            "pack": "items",
            "compendiumId": "lN1VbnGFo3HNZXNb",
            "name": "Half Plate Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-hide",
            "pack": "items",
            "compendiumId": "VRT5GEusTFstOZdF",
            "name": "Hide Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-leather",
            "pack": "items",
            "compendiumId": "dRtb9Tg34NKX9mGF",
            "name": "Leather Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-padded",
            "pack": "items",
            "compendiumId": "698gLyJ4JKVVMF53",
            "name": "Padded Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-plate",
            "pack": "items",
            "compendiumId": "azxwKFHrNmG3HpVy",
            "name": "Plate Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-ring-mail",
            "pack": "items",
            "compendiumId": "Wo2Dkh191C4VmLmg",
            "name": "Ring Mail Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-scale-mail",
            "pack": "items",
            "compendiumId": "f0I81P9k29Q1lV4S",
            "name": "Scale Mail Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-splint",
            "pack": "items",
            "compendiumId": "JNkjtTxYmEC7W34O",
            "name": "Splint Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-resistance-studded-leather",
            "pack": "items",
            "compendiumId": "W1kDsFekjroIywuz",
            "name": "Studded Leather Armor of Resistance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_armor-of-vulnerability",
            "pack": "items",
            "compendiumId": "YwS4pESpfsiq0JZv",
            "name": "Armor of Vulnerability",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_arrow-bow",
            "pack": "items",
            "compendiumId": "3c7JXOzsv55gqJS5",
            "name": "Arrow",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_arrow-catching-shield",
            "pack": "items",
            "compendiumId": "uWUD93jwuO2Jxkti",
            "name": "Arrow-Catching Shield",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_arrow-of-slaying",
            "pack": "items",
            "compendiumId": "aXsfZvDCdpuv3Yvb",
            "name": "Arrow of Slaying",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_backpack",
            "pack": "items",
            "compendiumId": "H8YCd689ezlD26aT",
            "name": "Backpack",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bag-of-beans",
            "pack": "items",
            "compendiumId": "F8QpasPjLrw2POzE",
            "name": "Bag of Beans",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bag-of-devouring",
            "pack": "items",
            "compendiumId": "YG9QW0flem4SLL6A",
            "name": "Bag of Devouring",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bag-of-holding",
            "pack": "items",
            "compendiumId": "aDHRuUs29SrumWfq",
            "name": "Bag of Holding",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bagpipes",
            "pack": "items",
            "compendiumId": "yxHi57T5mmVt0oDr",
            "name": "Bagpipes",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ball-bearings-bag-of-1000",
            "pack": "items",
            "compendiumId": "3YSUIp4eFo26YxJr",
            "name": "Ball Bearings",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_barrel",
            "pack": "items",
            "compendiumId": "7Yqbqg5EtVW16wfT",
            "name": "Barrel",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_basket",
            "pack": "items",
            "compendiumId": "Wv7HzD6dv1P0q78N",
            "name": "Basket",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_battleaxe",
            "pack": "items",
            "compendiumId": "I0WocDSuNpGJayPb",
            "name": "Battleaxe",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_battleaxe-1",
            "pack": "items",
            "compendiumId": "UAXu4MNvAvaKz9JO",
            "name": "Battleaxe +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_battleaxe-2",
            "pack": "items",
            "compendiumId": "cQ94oKUZN8FDAI8U",
            "name": "Battleaxe +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_battleaxe-3",
            "pack": "items",
            "compendiumId": "kNlvoSTcdMqxJPmI",
            "name": "Battleaxe +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bead-of-force",
            "pack": "items",
            "compendiumId": "SqTtbBCfiEsmZ36N",
            "name": "Bead of Force",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bedroll",
            "pack": "items",
            "compendiumId": "DVXmyetZuvxbzAwW",
            "name": "Bedroll",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bell",
            "pack": "items",
            "compendiumId": "F6GwSqjErX1u35Re",
            "name": "Bell",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_belt-of-cloud-giant-strength",
            "pack": "items",
            "compendiumId": "NRj0lC3SM03s1YB3",
            "name": "Belt of Cloud Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_belt-of-dwarvenkind",
            "pack": "items",
            "compendiumId": "j2ZGEwx8MhHZXds4",
            "name": "Belt of Dwarvenkind",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_belt-of-fire-giant-strength",
            "pack": "items",
            "compendiumId": "bq9YKwEHLQ7p7ric",
            "name": "Belt of Fire Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_belt-of-frost-giant-strength",
            "pack": "items",
            "compendiumId": "ORKf6RRcalrdD6Qp",
            "name": "Belt of Frost Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_belt-of-hill-giant-strength",
            "pack": "items",
            "compendiumId": "ER75WHewYN04Zp11",
            "name": "Belt of Hill Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_belt-of-stone-giant-strength",
            "pack": "items",
            "compendiumId": "fCUZ7h8YYrs16UhX",
            "name": "Belt of Stone Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_belt-of-storm-giant-strength",
            "pack": "items",
            "compendiumId": "wBYmPQG3nZfD88aP",
            "name": "Belt of Storm Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_blanket",
            "pack": "items",
            "compendiumId": "419eNv7xp2p7Xlo5",
            "name": "Blanket",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_block-and-tackle",
            "pack": "items",
            "compendiumId": "jlI44g90pp4VazBU",
            "name": "Block and Tackle",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_blowgun",
            "pack": "items",
            "compendiumId": "wNWK6yJMHG9ANqQV",
            "name": "Blowgun",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_blowgun-1",
            "pack": "items",
            "compendiumId": "N8XNP3vjVZmM2r9S",
            "name": "Blowgun +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_blowgun-2",
            "pack": "items",
            "compendiumId": "fu7DJcrYWfGMeVt9",
            "name": "Blowgun +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_blowgun-3",
            "pack": "items",
            "compendiumId": "HQJ8tiyyrJJSUSyF",
            "name": "Blowgun +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_blowgun-needles",
            "pack": "items",
            "compendiumId": "gBQ8xqTA5f8wP5iu",
            "name": "Blowgun Needle",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_book",
            "pack": "items",
            "compendiumId": "RMi9efrW9ouHVLI2",
            "name": "Book",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_boots-of-elvenkind",
            "pack": "items",
            "compendiumId": "KKWBLKQIWHtcpymp",
            "name": "Boots of Elvenkind",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_boots-of-levitation",
            "pack": "items",
            "compendiumId": "HLhFCDGfI8EK7uV9",
            "name": "Boots of Levitation",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_boots-of-speed",
            "pack": "items",
            "compendiumId": "MCMSZrhcD40oMJ9v",
            "name": "Boots of Speed",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_boots-of-striding-and-springing",
            "pack": "items",
            "compendiumId": "hSY1b8yi8JWw2blf",
            "name": "Boots of Striding and Springing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_boots-of-the-winterlands",
            "pack": "items",
            "compendiumId": "RDPFmUR9exTEXFc8",
            "name": "Boots of the Winterlands",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bottle-glass",
            "pack": "items",
            "compendiumId": "HZp69hhyNZUUCipF",
            "name": "Glass Bottle",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bowl-of-commanding-water-elementals",
            "pack": "items",
            "compendiumId": "rRMaaGZ7qbzqMvoI",
            "name": "Bowl of Commanding Water Elementals",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bracers-of-archery",
            "pack": "items",
            "compendiumId": "ZYEqOSY9BLZs2GPx",
            "name": "Bracers of Archery",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bracers-of-defense",
            "pack": "items",
            "compendiumId": "DSHi7yT6OUyDoCcu",
            "name": "Bracers of Defense",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_brazier-of-commanding-fire-elementals",
            "pack": "items",
            "compendiumId": "OcjcplcUWH07Kn9k",
            "name": "Brazier of Commanding Fire Elementals",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_breastplate",
            "pack": "items",
            "compendiumId": "SK2HATQ4abKUlV8i",
            "name": "Breastplate",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_brewers-supplies",
            "pack": "items",
            "compendiumId": "Y9S75go1hLMXUD48",
            "name": "Brewer's Supplies",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_brooch-of-shielding",
            "pack": "items",
            "compendiumId": "ZdcEtbtU3VkuxIFE",
            "name": "Brooch of Shielding",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_broom-of-flying",
            "pack": "items",
            "compendiumId": "hFAVm9pTJDm0nu3g",
            "name": "Broom of Flying",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_bucket",
            "pack": "items",
            "compendiumId": "mQVYcHmMSoCUnBnM",
            "name": "Bucket",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_calligraphers-supplies",
            "pack": "items",
            "compendiumId": "jhjo20QoiD5exf09",
            "name": "Calligrapher's Supplies",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_caltrops-bag-of-20",
            "pack": "items",
            "compendiumId": "8tvhh5wqG5FRh3Sf",
            "name": "Caltrops",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_candle",
            "pack": "items",
            "compendiumId": "0NoBBP3MMkvJlwZY",
            "name": "Candle",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_candle-of-invocation",
            "pack": "items",
            "compendiumId": "ZoUVmRA3HfAK2eZy",
            "name": "Candle of Invocation",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cape-of-the-mountebank",
            "pack": "items",
            "compendiumId": "gpHgWLsD8k2yzbfR",
            "name": "Cape of the Mountebank",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_carpenters-tools",
            "pack": "items",
            "compendiumId": "8NS6MSOdXtUqD7Ib",
            "name": "Carpenter's Tools",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cartographers-tools",
            "pack": "items",
            "compendiumId": "fC0lFK8P4RuhpfaU",
            "name": "Cartographer's Tools",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_case-crossbow-bolt",
            "pack": "items",
            "compendiumId": "eJtPBiZtr2pp6ynt",
            "name": "Crossbow Bolt Case",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_case-map-or-scroll",
            "pack": "items",
            "compendiumId": "5mIeX824uMklU3xq",
            "name": "Map or Scroll Case",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_censer-of-controlling-air-elementals",
            "pack": "items",
            "compendiumId": "sXEkkTDXWQDUMzsC",
            "name": "Censer of Controlling Air Elementals",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_chain-10-feet",
            "pack": "items",
            "compendiumId": "JvoufrTkSDMsS9Sm",
            "name": "Chain (10 feet)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_chain-mail",
            "pack": "items",
            "compendiumId": "rLMflzmxpe8JGTOA",
            "name": "Chain Mail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_chain-shirt",
            "pack": "items",
            "compendiumId": "p2zChy24ZJdVqMSH",
            "name": "Chain Shirt",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_chalk-1-piece",
            "pack": "items",
            "compendiumId": "5fJn3LQ2eQG7luEO",
            "name": "Chalk",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_chest",
            "pack": "items",
            "compendiumId": "2YbuclKfhDL0bU4u",
            "name": "Chest",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_chime-of-opening",
            "pack": "items",
            "compendiumId": "vZdLYfHlLcZqQ8zc",
            "name": "Chime of Opening",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_circlet-of-blasting",
            "pack": "items",
            "compendiumId": "9UvWQTY5yIgkJmmb",
            "name": "Circlet of Blasting",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_climbers-kit",
            "pack": "items",
            "compendiumId": "ugzwHl8vYaPu2GNd",
            "name": "Climber's Kit",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cloak-of-arachnida",
            "pack": "items",
            "compendiumId": "VwJjuNbBf2KHMPrY",
            "name": "Cloak of Arachnida",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cloak-of-displacement",
            "pack": "items",
            "compendiumId": "LpD064ilKEeFzVI8",
            "name": "Cloak of Displacement",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cloak-of-elvenkind",
            "pack": "items",
            "compendiumId": "Jvf1NWFxcjfHnMQ5",
            "name": "Cloak of Elvenkind",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cloak-of-protection",
            "pack": "items",
            "compendiumId": "lvaMqEhfidfHDGf5",
            "name": "Cloak of Protection",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cloak-of-the-bat",
            "pack": "items",
            "compendiumId": "Aq1rhgcgFnwu2T4I",
            "name": "Cloak of the Bat",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cloak-of-the-manta-ray",
            "pack": "items",
            "compendiumId": "hGrxC676XmlnS9y0",
            "name": "Cloak of the Manta Ray",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_clothes-common",
            "pack": "items",
            "compendiumId": "8RXjiddJ6VGyE7vB",
            "name": "Common Clothes",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_clothes-costume",
            "pack": "items",
            "compendiumId": "E2h6sEe6FU2tnU96",
            "name": "Costume Clothes",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_clothes-fine",
            "pack": "items",
            "compendiumId": "3OXueEpvDDCVfGFA",
            "name": "Fine Clothes",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_clothes-travelers",
            "pack": "items",
            "compendiumId": "SsAmWV6YBqeOFihT",
            "name": "Traveler's Clothes",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_club",
            "pack": "items",
            "compendiumId": "nfIRTECQIG81CvM4",
            "name": "Club",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_club-1",
            "pack": "items",
            "compendiumId": "fCRftM4QxEDkeu0a",
            "name": "Club +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_club-2",
            "pack": "items",
            "compendiumId": "gyJ0imAckcWtCjyv",
            "name": "Club +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_club-3",
            "pack": "items",
            "compendiumId": "HdC66U61pDOknaux",
            "name": "Club +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cobblers-tools",
            "pack": "items",
            "compendiumId": "hM84pZnpCqKfi8XH",
            "name": "Cobbler's Tools",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_component-pouch",
            "pack": "items",
            "compendiumId": "eZGmdOhaTWMicXPW",
            "name": "Component Pouch",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cooks-utensils",
            "pack": "items",
            "compendiumId": "Gflnp29aEv5Lc1ZM",
            "name": "Cook's Utensils",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-bolt",
            "pack": "items",
            "compendiumId": "SItCnYBqhzqBoaWG",
            "name": "Crossbow Bolt",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-hand",
            "pack": "items",
            "compendiumId": "qaSro7kFhxD6INbZ",
            "name": "Hand Crossbow",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-hand-1",
            "pack": "items",
            "compendiumId": "MnX9soPEMNsCtpv7",
            "name": "Hand Crossbow +1",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-hand-2",
            "pack": "items",
            "compendiumId": "3Q6rw9kAMf6F1SW5",
            "name": "Hand Crossbow +2",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-hand-3",
            "pack": "items",
            "compendiumId": "oG4rvCuMstgl4Nez",
            "name": "Hand Crossbow +3",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-heavy",
            "pack": "items",
            "compendiumId": "RmP0mYRn2J7K26rX",
            "name": "Heavy Crossbow",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-heavy-1",
            "pack": "items",
            "compendiumId": "ijDzcDXfJAdj2uED",
            "name": "Heavy Crossbow +1",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-heavy-2",
            "pack": "items",
            "compendiumId": "8wXB18E0oPAYFkqc",
            "name": "Heavy Crossbow +2",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-heavy-3",
            "pack": "items",
            "compendiumId": "Sj4zEvuGcSV6anKm",
            "name": "Heavy Crossbow +3",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-light",
            "pack": "items",
            "compendiumId": "ddWvQRLmnnIS0eLF",
            "name": "Light Crossbow",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-light-1",
            "pack": "items",
            "compendiumId": "kHjpHTKex95ULxUX",
            "name": "Light Crossbow +1",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-light-2",
            "pack": "items",
            "compendiumId": "x12sDhylcf8843fT",
            "name": "Light Crossbow +2",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crossbow-light-3",
            "pack": "items",
            "compendiumId": "amRx3jOYlPeXEiAN",
            "name": "Light Crossbow +3",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crowbar",
            "pack": "items",
            "compendiumId": "V5UAjT3ed6sDNtgm",
            "name": "Crowbar",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crystal",
            "pack": "items",
            "compendiumId": "uXOT4fYbgPY8DGdd",
            "name": "Crystal",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crystal-ball",
            "pack": "items",
            "compendiumId": "ItoGjtOtDOQ2noNM",
            "name": "Crystal Ball",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crystal-ball-of-mind-reading",
            "pack": "items",
            "compendiumId": "TwYeck6buBZ602mg",
            "name": "Crystal Ball of Mind Reading",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crystal-ball-of-telepathy",
            "pack": "items",
            "compendiumId": "5KiRtMMSTnJmMtBr",
            "name": "Crystal Ball of Telepathy",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_crystal-ball-of-true-seeing",
            "pack": "items",
            "compendiumId": "ADH0UZ8bf7Op0dgf",
            "name": "Crystal Ball of True Seeing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cube-of-force",
            "pack": "items",
            "compendiumId": "s4fR8bxQGSt4wbH7",
            "name": "Cube of Force",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_cubic-gate",
            "pack": "items",
            "compendiumId": "6ai1pEde3iQX30Fr",
            "name": "Cubic Gate",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dagger",
            "pack": "items",
            "compendiumId": "0E565kQUBmndJ1a2",
            "name": "Dagger",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dagger-1",
            "pack": "items",
            "compendiumId": "59pjg8FGM4GG4Fdd",
            "name": "Dagger +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dagger-2",
            "pack": "items",
            "compendiumId": "Lr8aRsnia8hftPAb",
            "name": "Dagger +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dagger-3",
            "pack": "items",
            "compendiumId": "bWI5i4RbyGKT6Eiq",
            "name": "Dagger +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dagger-of-venom",
            "pack": "items",
            "compendiumId": "7i4s9msZWpAw4Ynv",
            "name": "Dagger of Venom",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dancing-sword-greatsword",
            "pack": "items",
            "compendiumId": "zWSB0NCllWaSVoNT",
            "name": "Dancing Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dancing-sword-longsword",
            "pack": "items",
            "compendiumId": "sIiUbRJItYAs5gtA",
            "name": "Dancing Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dancing-sword-rapier",
            "pack": "items",
            "compendiumId": "6n8J07mFo8xs11vS",
            "name": "Dancing Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dancing-sword-shortsword",
            "pack": "items",
            "compendiumId": "stlFCpqW3ZuAftTi",
            "name": "Dancing Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dart",
            "pack": "items",
            "compendiumId": "3rCO8MTIdPGSW6IJ",
            "name": "Dart",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dart-1",
            "pack": "items",
            "compendiumId": "giU3yyZXvErjf78D",
            "name": "Dart +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dart-2",
            "pack": "items",
            "compendiumId": "EWdfUQriSabqDESm",
            "name": "Dart +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dart-3",
            "pack": "items",
            "compendiumId": "izF3kmyFEVI5TWhp",
            "name": "Dart +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_decanter-of-endless-water",
            "pack": "items",
            "compendiumId": "qXcUKfCVxEvV3VU8",
            "name": "Decanter of Endless Water",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_deck-of-illusions",
            "pack": "items",
            "compendiumId": "Wk7EOYoY3b2tgGoS",
            "name": "Deck of Illusions",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_deck-of-many-things",
            "pack": "items",
            "compendiumId": "oSarKEU8x1AupB6z",
            "name": "Deck of Many Things",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_defender-greatsword",
            "pack": "items",
            "compendiumId": "nSNhjX5F7f86AW1a",
            "name": "Defender Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_defender-longsword",
            "pack": "items",
            "compendiumId": "ukcKemEoTTRB9yLC",
            "name": "Defender Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_defender-rapier",
            "pack": "items",
            "compendiumId": "YrkkHa6KN8a9o35k",
            "name": "Defender Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_defender-shortsword",
            "pack": "items",
            "compendiumId": "d58CvI0Fiav9Jjt1",
            "name": "Defender Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_demon-armor",
            "pack": "items",
            "compendiumId": "ejEt6hLQxOux04lS",
            "name": "Demon Armor",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dice-set",
            "pack": "items",
            "compendiumId": "iBuTM09KD9IoM5L8",
            "name": "Dice Set",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dimensional-shackles",
            "pack": "items",
            "compendiumId": "wGKykLRS8UqChNXI",
            "name": "Dimensional Shackles",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_disguise-kit",
            "pack": "items",
            "compendiumId": "IBhDAr7WkhWPYLVn",
            "name": "Disguise Kit",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dragon-scale-mail",
            "pack": "items",
            "compendiumId": "tIwoSAGJlcuyiwaQ",
            "name": "Dragon Scale Mail",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dragon-slayer-greatsword",
            "pack": "items",
            "compendiumId": "orHjq3XDPz4eXcov",
            "name": "Dragon Slayer Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dragon-slayer-longsword",
            "pack": "items",
            "compendiumId": "SXjs8JghAPBv7d6j",
            "name": "Dragon Slayer Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dragon-slayer-rapier",
            "pack": "items",
            "compendiumId": "S7TrIOlE600KIOUx",
            "name": "Dragon Slayer Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dragon-slayer-shortsword",
            "pack": "items",
            "compendiumId": "MFd96UkSs5g9QO78",
            "name": "Dragon Slayer Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_drum",
            "pack": "items",
            "compendiumId": "69Dpr25pf4BjkHKb",
            "name": "Drum",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dulcimer",
            "pack": "items",
            "compendiumId": "NtdDkjmpdIMiX7I2",
            "name": "Dulcimer",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dust-of-disappearance",
            "pack": "items",
            "compendiumId": "cGUPm15mLfhGDz2b",
            "name": "Dust of Disappearance",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dust-of-dryness",
            "pack": "items",
            "compendiumId": "eMR6B4bIoJPUDJG8",
            "name": "Dust of Dryness",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dust-of-sneezing-and-choking",
            "pack": "items",
            "compendiumId": "9eyZY9tL3fXD1Mbm",
            "name": "Dust of Sneezing and Choking",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dwarven-plate",
            "pack": "items",
            "compendiumId": "OwqRt1pVLhdMQa0d",
            "name": "Dwarven Plate",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_dwarven-thrower",
            "pack": "items",
            "compendiumId": "kvD4ElYCfCKpjDeg",
            "name": "Dwarven Thrower",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_efficient-quiver",
            "pack": "items",
            "compendiumId": "MLNzQUsVUi0PEV3i",
            "name": "Efficient Quiver",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_efreeti-bottle",
            "pack": "items",
            "compendiumId": "fbcQsOgWCjhEAGY7",
            "name": "Efreeti Bottle",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_elven-chain",
            "pack": "items",
            "compendiumId": "6067acDZGv7KNOkP",
            "name": "Elven Chain",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_emblem",
            "pack": "items",
            "compendiumId": "laVqttkGMW4B9654",
            "name": "Emblem",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_eversmoking-bottle",
            "pack": "items",
            "compendiumId": "CvzjhUy9ekRieR1A",
            "name": "Eversmoking Bottle",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_eyes-of-charming",
            "pack": "items",
            "compendiumId": "8dfhaa1g3VDjhtm3",
            "name": "Eyes of Charming",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_eyes-of-minute-seeing",
            "pack": "items",
            "compendiumId": "BsyPV6eTNghT3Fho",
            "name": "Eyes of Minute Seeing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_eyes-of-the-eagle",
            "pack": "items",
            "compendiumId": "U4PI6l96QJUk6TGb",
            "name": "Eyes of the Eagle",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_figurine-of-wondrous-power-bronze-griffon",
            "pack": "items",
            "compendiumId": "CI58LNiwrTpmWYMp",
            "name": "Figurine of Wondrous Power (Bronze Griffon)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_figurine-of-wondrous-power-ebony-fly",
            "pack": "items",
            "compendiumId": "s2kQs21J3cFg7ZSs",
            "name": "Figurine of Wondrous Power (Ebony Fly)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_figurine-of-wondrous-power-golden-lions",
            "pack": "items",
            "compendiumId": "Minr6xegwoHFvAjG",
            "name": "Figurine of Wondrous Power (Golden Lions)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_figurine-of-wondrous-power-marble-elephant",
            "pack": "items",
            "compendiumId": "GP2bvHlxVi30OEmo",
            "name": "Figurine of Wondrous Power (Marble Elephant)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_figurine-of-wondrous-power-obsidian-steed",
            "pack": "items",
            "compendiumId": "M5qkJ7erLqWYUHa0",
            "name": "Figurine of Wondrous Power (Obsidian Steed)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_figurine-of-wondrous-power-onyx-dog",
            "pack": "items",
            "compendiumId": "9nxSHbqlDdngtuuz",
            "name": "Figurine of Wondrous Power (Onyx Dog)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_figurine-of-wondrous-power-serpentine-owl",
            "pack": "items",
            "compendiumId": "XEH5YErAN1WSytln",
            "name": "Figurine of Wondrous Power (Serpentine Owl)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_figurine-of-wondrous-power-silver-raven",
            "pack": "items",
            "compendiumId": "nMtmxeYrbyFdv0bg",
            "name": "Figurine of Wondrous Power (Silver Raven)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_fishing-tackle",
            "pack": "items",
            "compendiumId": "hOzuSDqmOIOx8z3Z",
            "name": "Fishing Tackle",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_flail",
            "pack": "items",
            "compendiumId": "UrH3sMdnUDckIHJ6",
            "name": "Flail",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_flail-1",
            "pack": "items",
            "compendiumId": "0LVFLPmsu1b2vf8E",
            "name": "Flail +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_flail-2",
            "pack": "items",
            "compendiumId": "z0lIRURcyDYt1kLK",
            "name": "Flail +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_flail-3",
            "pack": "items",
            "compendiumId": "wgBKZNeRN1XsE9I7",
            "name": "Flail +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_flame-tongue-greatsword",
            "pack": "items",
            "compendiumId": "WWb4vAmh18sMAxfY",
            "name": "Flame Tongue Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_flame-tongue-longsword",
            "pack": "items",
            "compendiumId": "ducaFdrqwLZ0l3c7",
            "name": "Flame Tongue Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_flame-tongue-rapier",
            "pack": "items",
            "compendiumId": "CoUFHk5keIihsbYL",
            "name": "Flame Tongue Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_flame-tongue-shortsword",
            "pack": "items",
            "compendiumId": "Z9FBwEoMi6daDGRj",
            "name": "Flame Tongue Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_flute",
            "pack": "items",
            "compendiumId": "eJOrPcAz9EcquyRQ",
            "name": "Flute",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_folding-boat",
            "pack": "items",
            "compendiumId": "u4ewpAFZjLrWrmQv",
            "name": "Folding Boat",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_forgery-kit",
            "pack": "items",
            "compendiumId": "cG3m4YlHfbQlLEOx",
            "name": "Forgery Kit",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_frost-brand-greatsword",
            "pack": "items",
            "compendiumId": "ykB6UKv5BuQnSRSL",
            "name": "Frost Brand Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_frost-brand-longsword",
            "pack": "items",
            "compendiumId": "NmZMx2u6bHpRyGUa",
            "name": "Frost Brand Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_frost-brand-rapier",
            "pack": "items",
            "compendiumId": "efluRemOguW2YeZY",
            "name": "Frost Brand Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_frost-brand-shortsword",
            "pack": "items",
            "compendiumId": "DT02xK1DzxLNlVaI",
            "name": "Frost Brand Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_gauntlets-of-ogre-power",
            "pack": "items",
            "compendiumId": "3TWT5bv3z5zGUZCe",
            "name": "Gauntlets of Ogre Power",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_gem-of-brightness",
            "pack": "items",
            "compendiumId": "thkvJ5QBRORIwkkV",
            "name": "Gem of Brightness",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_gem-of-seeing",
            "pack": "items",
            "compendiumId": "jJU8vFhHLQeKe2wu",
            "name": "Gem of Seeing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_giant-slayer-battleaxe",
            "pack": "items",
            "compendiumId": "YM6bZNmpync83VFa",
            "name": "Giant Slayer Battleaxe",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_giant-slayer-greataxe",
            "pack": "items",
            "compendiumId": "jmSC8I5awCoxNVv7",
            "name": "Giant Slayer Greataxe",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_giant-slayer-greatsword",
            "pack": "items",
            "compendiumId": "nBFr5xTWeChM7xrb",
            "name": "Giant Slayer Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_giant-slayer-handaxe",
            "pack": "items",
            "compendiumId": "F3rQcaZvElNEiudk",
            "name": "Giant Slayer Handaxe",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_giant-slayer-longsword",
            "pack": "items",
            "compendiumId": "xw2kL7Puwg4wfjW3",
            "name": "Giant Slayer Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_giant-slayer-rapier",
            "pack": "items",
            "compendiumId": "I5PWgE4IF40Iv9h4",
            "name": "Giant Slayer Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_giant-slayer-shortsword",
            "pack": "items",
            "compendiumId": "tTqixDDmzAfs995G",
            "name": "Giant Slayer Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_glaive",
            "pack": "items",
            "compendiumId": "rOG1OM2ihgPjOvFW",
            "name": "Glaive",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_glaive-1",
            "pack": "items",
            "compendiumId": "09i8r1UmzDSKiZ9g",
            "name": "Glaive +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_glaive-2",
            "pack": "items",
            "compendiumId": "Mt2WB1W9nDWO4d16",
            "name": "Glaive +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_glaive-3",
            "pack": "items",
            "compendiumId": "rc9nkN6YOD7ogtEi",
            "name": "Glaive +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_glamoured-studded-leather",
            "pack": "items",
            "compendiumId": "SypSoinJkES0o5FB",
            "name": "Glamoured Studded Leather",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_glassblowers-tools",
            "pack": "items",
            "compendiumId": "rTbVrNcwApnuTz5E",
            "name": "Glassblower's Tools",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_gloves-of-missile-snaring",
            "pack": "items",
            "compendiumId": "otYAEwhsANKHZAmk",
            "name": "Gloves of Missile Snaring",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_gloves-of-swimming-and-climbing",
            "pack": "items",
            "compendiumId": "PRhtLbRLb9LjHZG7",
            "name": "Gloves of Swimming and Climbing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_goggles-of-night",
            "pack": "items",
            "compendiumId": "XGAWqtmhK6SYBL6A",
            "name": "Goggles of Night",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_grappling-hook",
            "pack": "items",
            "compendiumId": "tfDxZIKDpOkz6pbx",
            "name": "Grappling Hook",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greataxe",
            "pack": "items",
            "compendiumId": "1Lxk6kmoRhG8qQ0u",
            "name": "Greataxe",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greataxe-1",
            "pack": "items",
            "compendiumId": "qhdGVfT5j6u46mtk",
            "name": "Greataxe +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greataxe-2",
            "pack": "items",
            "compendiumId": "hdUzXzVPonOQzW81",
            "name": "Greataxe +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greataxe-3",
            "pack": "items",
            "compendiumId": "PAa2EG5kzmqxcp46",
            "name": "Greataxe +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greatclub",
            "pack": "items",
            "compendiumId": "QRCsxkCwWNwswL9o",
            "name": "Greatclub",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greatclub-1",
            "pack": "items",
            "compendiumId": "dwGxrGqkn2ppNaqs",
            "name": "Greatclub +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greatclub-2",
            "pack": "items",
            "compendiumId": "Or3kVfJ0Fbr33ARS",
            "name": "Greatclub +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greatclub-3",
            "pack": "items",
            "compendiumId": "mkyltDYnuzNU3kmF",
            "name": "Greatclub +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greatsword",
            "pack": "items",
            "compendiumId": "xMkP8BmFzElcsMaR",
            "name": "Greatsword",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greatsword-1",
            "pack": "items",
            "compendiumId": "kBVK2IiZYRkEYtcM",
            "name": "Greatsword +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greatsword-2",
            "pack": "items",
            "compendiumId": "8LZBOY5USLZ4ngDq",
            "name": "Greatsword +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_greatsword-3",
            "pack": "items",
            "compendiumId": "RfEZvwcLwe6Ih0LQ",
            "name": "Greatsword +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_halberd",
            "pack": "items",
            "compendiumId": "DMejWAc8r8YvDPP1",
            "name": "Halberd",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_halberd-1",
            "pack": "items",
            "compendiumId": "nl7cc7Z1HpSHbUdQ",
            "name": "Halberd +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_halberd-2",
            "pack": "items",
            "compendiumId": "6ndqUhOySYVVQ5on",
            "name": "Halberd +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_halberd-3",
            "pack": "items",
            "compendiumId": "EU78dSbnr91QWZ7g",
            "name": "Halberd +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_half-plate",
            "pack": "items",
            "compendiumId": "vsgmACFYINloIdPm",
            "name": "Half Plate Armor",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_hammer",
            "pack": "items",
            "compendiumId": "14pNRT4sZy9rgvhb",
            "name": "Hammer",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_hammer-of-thunderbolts",
            "pack": "items",
            "compendiumId": "wGDDt17DpBcXPuUD",
            "name": "Hammer of Thunderbolts",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_hammer-sledge",
            "pack": "items",
            "compendiumId": "9G9QGSPgpZDSsm37",
            "name": "Sledgehammer",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_handaxe",
            "pack": "items",
            "compendiumId": "eO7Fbv5WBk5zvGOc",
            "name": "Handaxe",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_handaxe-1",
            "pack": "items",
            "compendiumId": "Qfi5Rsuun3reqYmf",
            "name": "Handaxe +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_handaxe-2",
            "pack": "items",
            "compendiumId": "LZcpcR21nte4Yoe2",
            "name": "Handaxe +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_handaxe-3",
            "pack": "items",
            "compendiumId": "cmnBssaWWzWWm70C",
            "name": "Handaxe +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_handy-haversack",
            "pack": "items",
            "compendiumId": "7vqs5AqI4VCmuszx",
            "name": "Handy Haversack",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_hat-of-disguise",
            "pack": "items",
            "compendiumId": "dQxqcjDm0IxYusCV",
            "name": "Hat of Disguise",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_headband-of-intellect",
            "pack": "items",
            "compendiumId": "a26LjC4QxP1oorXC",
            "name": "Headband of Intellect",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_healers-kit",
            "pack": "items",
            "compendiumId": "6rocoBx5jdzG1QQH",
            "name": "Healer's Kit",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_helm-of-brilliance",
            "pack": "items",
            "compendiumId": "rhGulc3gEJhnuP31",
            "name": "Helm of Brilliance",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_helm-of-comprehending-languages",
            "pack": "items",
            "compendiumId": "rY9sRFQp5CFSfsat",
            "name": "Helm of Comprehending Languages",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_helm-of-telepathy",
            "pack": "items",
            "compendiumId": "EJVaAvNfCq6gn6VG",
            "name": "Helm of Telepathy",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_helm-of-teleportation",
            "pack": "items",
            "compendiumId": "DEQkJiQdGyfmSNkV",
            "name": "Helm of Teleportation",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_herbalism-kit",
            "pack": "items",
            "compendiumId": "i89okN7GFTWHsvPy",
            "name": "Herbalism Kit",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_hide-armor",
            "pack": "items",
            "compendiumId": "n1V07puo0RQxPGuF",
            "name": "Hide Armor",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_holy-avenger-greatsword",
            "pack": "items",
            "compendiumId": "FCxG64QUxsnF4Lis",
            "name": "Holy Avenger Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_holy-avenger-longsword",
            "pack": "items",
            "compendiumId": "dZ9zWfhsIlabadKL",
            "name": "Holy Avenger Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_holy-avenger-rapier",
            "pack": "items",
            "compendiumId": "kTxi62RTrrdrIBr9",
            "name": "Holy Avenger Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_holy-avenger-shortsword",
            "pack": "items",
            "compendiumId": "bHbbIhbTzu4lYMRz",
            "name": "Holy Avenger Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_holy-water-flask",
            "pack": "items",
            "compendiumId": "WPWszFTGzmdIuDRJ",
            "name": "Flask of Holy Water",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_horn",
            "pack": "items",
            "compendiumId": "aa9KuBy4dst7WIW9",
            "name": "Horn",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_horn-of-blasting",
            "pack": "items",
            "compendiumId": "t7GfyRp3dB3lqS9i",
            "name": "Horn of Blasting",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_horn-of-valhalla-brass",
            "pack": "items",
            "compendiumId": "QYJyQCnIQeLiMrmJ",
            "name": "Brass Horn of Valhalla",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_horn-of-valhalla-bronze",
            "pack": "items",
            "compendiumId": "sqcerAMszpe3hwyI",
            "name": "Bronze Horn of Valhalla",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_horn-of-valhalla-iron",
            "pack": "items",
            "compendiumId": "qVuZznv0MnIjDU70",
            "name": "Iron Horn of Valhalla",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_horn-of-valhalla-silver",
            "pack": "items",
            "compendiumId": "lTfo6OVvAY2iJ4oq",
            "name": "Silver Horn of Valhalla",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_horseshoes-of-a-zephyr",
            "pack": "items",
            "compendiumId": "2mvXGvDmHHhzbT04",
            "name": "Horseshoes of a Zephyr",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_horseshoes-of-speed",
            "pack": "items",
            "compendiumId": "nAqDwI9GyXS1diiz",
            "name": "Horseshoes of Speed",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_hourglass",
            "pack": "items",
            "compendiumId": "G7LqGzKR5ts0WlJ9",
            "name": "Hourglass",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_hunting-trap",
            "pack": "items",
            "compendiumId": "LiOD83I4MIZlpoQQ",
            "name": "Hunting Trap",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_immovable-rod",
            "pack": "items",
            "compendiumId": "eQNXan0zp279jDtk",
            "name": "Immovable Rod",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ink-1-ounce-bottle",
            "pack": "items",
            "compendiumId": "dP7jMKyHTTgVb3ii",
            "name": "Ink Bottle",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ink-pen",
            "pack": "items",
            "compendiumId": "uVm7MiB71QblfnoY",
            "name": "Ink Pen",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_instant-fortress",
            "pack": "items",
            "compendiumId": "9stfX2i2I1YPo8vx",
            "name": "Instant Fortress",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-absorption",
            "pack": "items",
            "compendiumId": "NGVEouqK0I6J6jV5",
            "name": "Ioun Stone of Absorption",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-agility",
            "pack": "items",
            "compendiumId": "Q4Iy6hqREsbk9yG7",
            "name": "Ioun Stone of Agility",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-awareness",
            "pack": "items",
            "compendiumId": "h8rS84jKsMHl9J1i",
            "name": "Ioun Stone of Awareness",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-greater-absorption",
            "pack": "items",
            "compendiumId": "7FEcfqz1piPHN1tV",
            "name": "Ioun Stone of Greater Absorption",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-insight",
            "pack": "items",
            "compendiumId": "9jMQEm99q1ttAV1Q",
            "name": "Ioun Stone of Insight",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-intellect",
            "pack": "items",
            "compendiumId": "YeLz5OxRNxmvHJId",
            "name": "Ioun Stone of Intellect",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-leadership",
            "pack": "items",
            "compendiumId": "hDF4RSCzMO8iI14x",
            "name": "Ioun Stone of Leadership",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-mastery",
            "pack": "items",
            "compendiumId": "nk2MH16KcZmKp7FQ",
            "name": "Ioun Stone of Mastery",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-protection",
            "pack": "items",
            "compendiumId": "v4uNbmiz4ECTI89n",
            "name": "Ioun Stone of Protection",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-regeneration",
            "pack": "items",
            "compendiumId": "szNhDWpks5BhEXhT",
            "name": "Ioun Stone of Regeneration",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-reserve",
            "pack": "items",
            "compendiumId": "jvKmgJYL33E8gev5",
            "name": "Ioun Stone of Reserve",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-strength",
            "pack": "items",
            "compendiumId": "0G5LSgbb5NTV4XC7",
            "name": "Ioun Stone of Strength",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ioun-stone-sustenance",
            "pack": "items",
            "compendiumId": "6MDTnMG4Hcw7qZsy",
            "name": "Ioun Stone of Sustenance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_iron-bands-of-binding",
            "pack": "items",
            "compendiumId": "E9G4jALlSA96fKAN",
            "name": "Iron Bands of Binding",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_iron-flask",
            "pack": "items",
            "compendiumId": "lvLrkAR7k8DS7J3W",
            "name": "Iron Flask",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_javelin",
            "pack": "items",
            "compendiumId": "DWLMnODrnHn8IbAG",
            "name": "Javelin",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_javelin-1",
            "pack": "items",
            "compendiumId": "idtlcnIWgwVdvp31",
            "name": "Javelin +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_javelin-2",
            "pack": "items",
            "compendiumId": "gV671PZGnYoVZefN",
            "name": "Javelin +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_javelin-3",
            "pack": "items",
            "compendiumId": "FhtjbeBeP4q5vTyc",
            "name": "Javelin +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_javelin-of-lightning",
            "pack": "items",
            "compendiumId": "LEC1wkaAUnWzDPDD",
            "name": "Javelin of Lightning",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_jewelers-tools",
            "pack": "items",
            "compendiumId": "YfBwELTgPFHmQdHh",
            "name": "Jeweler's Tools",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ladder-10-foot",
            "pack": "items",
            "compendiumId": "eQTKbhnpkrtXUfwN",
            "name": "Ladder (10-foot)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lamp",
            "pack": "items",
            "compendiumId": "qMzHmlmha8qMDnEF",
            "name": "Lamp",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lamp-oil-flask",
            "pack": "items",
            "compendiumId": "psoZaItkOScMVaHL",
            "name": "Oil Flask",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lance",
            "pack": "items",
            "compendiumId": "RnuxdHUAIgxccVwj",
            "name": "Lance",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lance-1",
            "pack": "items",
            "compendiumId": "l88FXiodYofrJT8a",
            "name": "Lance +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lance-2",
            "pack": "items",
            "compendiumId": "CVMGOJWTO6TCybrH",
            "name": "Lance +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lance-3",
            "pack": "items",
            "compendiumId": "r97KnMO7Zxgfdh3P",
            "name": "Lance +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lantern-bullseye",
            "pack": "items",
            "compendiumId": "UkWdyJYQTfVX2cJW",
            "name": "Bullseye Lantern",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lantern-hooded",
            "pack": "items",
            "compendiumId": "trmWAdUoR6Y2B7rA",
            "name": "Hooded Lantern",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lantern-of-revealing",
            "pack": "items",
            "compendiumId": "7FLs8qIGdOFnz9oL",
            "name": "Lantern of Revealing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_leather-armor",
            "pack": "items",
            "compendiumId": "WwdpHLXGX5r8uZu5",
            "name": "Leather Armor",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_leatherworkers-tools",
            "pack": "items",
            "compendiumId": "PUMfwyVUbtyxgYbD",
            "name": "Leatherworker's Tools",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_light-hammer",
            "pack": "items",
            "compendiumId": "XVK6TOL4sGItssAE",
            "name": "Light Hammer",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_light-hammer-1",
            "pack": "items",
            "compendiumId": "q24QnImAicnT9Byd",
            "name": "Light Hammer +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_light-hammer-2",
            "pack": "items",
            "compendiumId": "XIpJkxbySJxm6hoU",
            "name": "Light Hammer +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_light-hammer-3",
            "pack": "items",
            "compendiumId": "Y08Al2dMN8he1hFK",
            "name": "Light Hammer +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lock",
            "pack": "items",
            "compendiumId": "xwUWrV15s9jLnmfZ",
            "name": "Lock",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_longbow",
            "pack": "items",
            "compendiumId": "3cymOVja8jXbzrdT",
            "name": "Longbow",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_longbow-1",
            "pack": "items",
            "compendiumId": "A2i08i8gAFscm6hZ",
            "name": "Longbow +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_longbow-2",
            "pack": "items",
            "compendiumId": "ZcvU9rRb573NOywv",
            "name": "Longbow +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_longbow-3",
            "pack": "items",
            "compendiumId": "8W6ULfSqzuHh6Peg",
            "name": "Longbow +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_longsword",
            "pack": "items",
            "compendiumId": "10ZP2Bu3vnCuYMIB",
            "name": "Longsword",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_longsword-1",
            "pack": "items",
            "compendiumId": "IPkf0XNowClwXnjQ",
            "name": "Longsword +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_longsword-2",
            "pack": "items",
            "compendiumId": "bcv7J9culilK68zp",
            "name": "Longsword +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_longsword-3",
            "pack": "items",
            "compendiumId": "H6SIiRIig7OMM2Z0",
            "name": "Longsword +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_luck-blade-greatsword",
            "pack": "items",
            "compendiumId": "fWR9EFEjR0JtFdCC",
            "name": "Luck Blade Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_luck-blade-longsword",
            "pack": "items",
            "compendiumId": "X6PHssSGnwiJRgcx",
            "name": "Luck Blade Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_luck-blade-rapier",
            "pack": "items",
            "compendiumId": "qGH7YqWhi0tHisMi",
            "name": "Luck Blade Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_luck-blade-shortsword",
            "pack": "items",
            "compendiumId": "nL0Y0X8SjF58OmBM",
            "name": "Luck Blade Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lute",
            "pack": "items",
            "compendiumId": "qBydtUUIkv520DT7",
            "name": "Lute",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_lyre",
            "pack": "items",
            "compendiumId": "EwG1EtmbgR3bM68U",
            "name": "Lyre",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mace",
            "pack": "items",
            "compendiumId": "Ajyq6nGwF7FtLhDQ",
            "name": "Mace",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mace-1",
            "pack": "items",
            "compendiumId": "jf0XMx2vfEZzZuD7",
            "name": "Mace +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mace-2",
            "pack": "items",
            "compendiumId": "m1hJnK7CHsaJB26v",
            "name": "Mace +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mace-3",
            "pack": "items",
            "compendiumId": "2CQnAvn06bncXPBt",
            "name": "Mace +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mace-of-disruption",
            "pack": "items",
            "compendiumId": "m7RubLd1lUcMjYgY",
            "name": "Mace of Disruption",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mace-of-smiting",
            "pack": "items",
            "compendiumId": "w56FIjFafs2rN6iK",
            "name": "Mace of Smiting",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mace-of-terror",
            "pack": "items",
            "compendiumId": "b46t42bMruQf9v3O",
            "name": "Mace of Terror",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_magnifying-glass",
            "pack": "items",
            "compendiumId": "PV0sn2Nlr8CNn4W9",
            "name": "Magnifying Glass",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_manacles",
            "pack": "items",
            "compendiumId": "tWJLHIL6ZIZUez9k",
            "name": "Manacles",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mantle-of-spell-resistance",
            "pack": "items",
            "compendiumId": "oxzUb5j1TMsccGW4",
            "name": "Mantle of Spell Resistance",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_manual-of-bodily-health",
            "pack": "items",
            "compendiumId": "BjyTJn9oGvURWKJR",
            "name": "Manual of Bodily Health",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_manual-of-gainful-exercise",
            "pack": "items",
            "compendiumId": "ykefWXBjq3y6y9Se",
            "name": "Manual of Gainful Exercise",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_manual-of-golems",
            "pack": "items",
            "compendiumId": "UxkP6FvDzPbsIY6o",
            "name": "Manual of Golems",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_manual-of-quickness-of-action",
            "pack": "items",
            "compendiumId": "Q4jmng3i9Lb2nL5F",
            "name": "Manual of Quickness of Action",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_marvelous-pigments",
            "pack": "items",
            "compendiumId": "e3XQygrXkzNvkDGF",
            "name": "Marvelous Pigments",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_masons-tools",
            "pack": "items",
            "compendiumId": "skUih6tBvcBbORzA",
            "name": "Mason's Tools",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_maul",
            "pack": "items",
            "compendiumId": "DizirD7eqjh8n95A",
            "name": "Maul",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_maul-1",
            "pack": "items",
            "compendiumId": "EveBprZPBjfZqXLt",
            "name": "Maul +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_maul-2",
            "pack": "items",
            "compendiumId": "1kihEfn9QppB34ee",
            "name": "Maul +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_maul-3",
            "pack": "items",
            "compendiumId": "P8f9o36qxagW2uRW",
            "name": "Maul +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_medallion-of-thoughts",
            "pack": "items",
            "compendiumId": "skoUe223EvRYGPL6",
            "name": "Medallion of Thoughts",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mess-kit",
            "pack": "items",
            "compendiumId": "V13fjV5oSmvbRdgP",
            "name": "Mess Kit",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mirror-of-life-trapping",
            "pack": "items",
            "compendiumId": "hf5j1meGsA33HkUj",
            "name": "Mirror of Life Trapping",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mirror-steel",
            "pack": "items",
            "compendiumId": "HZsvDPmvysQKGzGy",
            "name": "Steel Mirror",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mithral-armor-breastplate",
            "pack": "items",
            "compendiumId": "CcTGZzQHejxEVLK1",
            "name": "Mithral Breastplate",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mithral-armor-chain-mail",
            "pack": "items",
            "compendiumId": "YS9CRHg2yQlOVi3j",
            "name": "Mithral Chain Mail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mithral-armor-chain-shirt",
            "pack": "items",
            "compendiumId": "3h3ZU6qmQs18FfkA",
            "name": "Mithral Chain Shirt",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mithral-armor-half-plate",
            "pack": "items",
            "compendiumId": "qRMQH8lRE42JkugE",
            "name": "Mithral Half Plate Armor",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mithral-armor-plate",
            "pack": "items",
            "compendiumId": "HVpXIU0zZw0a4Fb7",
            "name": "Mithral Plate Armor",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mithral-armor-ring-mail",
            "pack": "items",
            "compendiumId": "tJQXAJx92wL6GM1v",
            "name": "Mithral Ring Mail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mithral-armor-scale-mail",
            "pack": "items",
            "compendiumId": "iRDmig2qZ7LdP0ug",
            "name": "Mithral Scale Mail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_mithral-armor-splint",
            "pack": "items",
            "compendiumId": "GKQSxYvS3m9qKVac",
            "name": "Mithral Splint Armor",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_morningstar",
            "pack": "items",
            "compendiumId": "dX8AxCh9o0A9CkT3",
            "name": "Morningstar",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_morningstar-1",
            "pack": "items",
            "compendiumId": "PKpftwMAn88gfLi7",
            "name": "Morningstar +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_morningstar-2",
            "pack": "items",
            "compendiumId": "NrHboku9vJO5FGiY",
            "name": "Morningstar +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_morningstar-3",
            "pack": "items",
            "compendiumId": "dghpiMWDSUXtQf6X",
            "name": "Morningstar +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_navigators-tools",
            "pack": "items",
            "compendiumId": "YHCmjsiXxZ9UdUhU",
            "name": "Navigator's Tools",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_necklace-of-adaptation",
            "pack": "items",
            "compendiumId": "wwNpAz2KMukovewN",
            "name": "Necklace of Adaptation",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_necklace-of-fireballs",
            "pack": "items",
            "compendiumId": "3ALOhh6JNInIK4o7",
            "name": "Necklace of Fireballs",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_necklace-of-prayer-beads",
            "pack": "items",
            "compendiumId": "wqVSRfkcTjuhvDyx",
            "name": "Necklace of Prayer Beads",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_net",
            "pack": "items",
            "compendiumId": "aEiM49V8vWpWw7rU",
            "name": "Net",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_net-1",
            "pack": "items",
            "compendiumId": "rJKXDPikXSYXYgb5",
            "name": "Net +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_net-2",
            "pack": "items",
            "compendiumId": "hHX5qXva1ScCpBpL",
            "name": "Net +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_net-3",
            "pack": "items",
            "compendiumId": "iIuNqnpWCHrLEKWj",
            "name": "Net +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_nine-lives-stealer-greatsword",
            "pack": "items",
            "compendiumId": "tFLmAPUDLxBY8jFO",
            "name": "Nine Lives Stealer Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_nine-lives-stealer-longsword",
            "pack": "items",
            "compendiumId": "BefbYlWbRYyy6R8s",
            "name": "Nine Lives Stealer Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_nine-lives-stealer-rapier",
            "pack": "items",
            "compendiumId": "OUGMoQYeJzxEcRvm",
            "name": "Nine Lives Stealer Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_nine-lives-stealer-shortsword",
            "pack": "items",
            "compendiumId": "2Lkub0qIwucWEfp3",
            "name": "Nine Lives Stealer Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_oathbow",
            "pack": "items",
            "compendiumId": "mGIwk9FwTAJB6qTn",
            "name": "Oathbow",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_oil-of-etherealness",
            "pack": "items",
            "compendiumId": "Xbq8CyXSRV358SfP",
            "name": "Oil of Etherealness",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_oil-of-sharpness",
            "pack": "items",
            "compendiumId": "C0MNXWA81ufzGlp5",
            "name": "Oil of Sharpness",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_oil-of-slipperiness",
            "pack": "items",
            "compendiumId": "FIDyR0kZnxGy7bj8",
            "name": "Oil of Slipperiness",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_orb",
            "pack": "items",
            "compendiumId": "tH5Rn0JVRG1zdmPa",
            "name": "Orb",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_orb-of-dragonkind",
            "pack": "items",
            "compendiumId": "1RwJWOAeyoideLKe",
            "name": "Orb of Dragonkind",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_padded-armor",
            "pack": "items",
            "compendiumId": "GtKV1b5uqFQqpEni",
            "name": "Padded Armor",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_painters-supplies",
            "pack": "items",
            "compendiumId": "ccm5xlWhx74d6lsK",
            "name": "Painter's Supplies",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pan-flute",
            "pack": "items",
            "compendiumId": "G5m5gYIx9VAUWC3J",
            "name": "Pan Flute",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_paper-one-sheet",
            "pack": "items",
            "compendiumId": "fNMkFCOvMiW2Rh3t",
            "name": "Paper",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_parchment-one-sheet",
            "pack": "items",
            "compendiumId": "WFQS2vT8ddrFjTJg",
            "name": "Parchment",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pearl-of-power",
            "pack": "items",
            "compendiumId": "44XNWmMGnwXn7bNW",
            "name": "Pearl of Power",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_perfume-vial",
            "pack": "items",
            "compendiumId": "uuh4UH3Jx5CsFjdA",
            "name": "Perfume",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_periapt-of-health",
            "pack": "items",
            "compendiumId": "9v0TPDXNa9S7aNB4",
            "name": "Periapt of Health",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_periapt-of-proof-against-poison",
            "pack": "items",
            "compendiumId": "oYZNXHth1UYxPwVi",
            "name": "Periapt of Proof against Poison",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_periapt-of-wound-closure",
            "pack": "items",
            "compendiumId": "DWwBkOFuYf5VN3M2",
            "name": "Periapt of Wound Closure",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_philter-of-love",
            "pack": "items",
            "compendiumId": "63nb14yQRJMc4bIn",
            "name": "Philter of Love",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pick-miners",
            "pack": "items",
            "compendiumId": "X5knPtrQAT8GePJ4",
            "name": "Miner's Pick",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pike",
            "pack": "items",
            "compendiumId": "tC0kcqZT9HHAO0PD",
            "name": "Pike",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pike-1",
            "pack": "items",
            "compendiumId": "yoFff2zdTloKx1if",
            "name": "Pike +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pike-2",
            "pack": "items",
            "compendiumId": "qcEiSj67zfbLvYdJ",
            "name": "Pike +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pike-3",
            "pack": "items",
            "compendiumId": "3YH1o1Wa4gcdN3fh",
            "name": "Pike +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pipes-of-haunting",
            "pack": "items",
            "compendiumId": "oNLfJNRQgUHpU8c7",
            "name": "Pipes of Haunting",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pipes-of-the-sewers",
            "pack": "items",
            "compendiumId": "nvhk1quD0Dg1ZtSH",
            "name": "Pipes of the Sewers",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_piton",
            "pack": "items",
            "compendiumId": "TqyvIglHDj5kfohR",
            "name": "Piton",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_plate-armor",
            "pack": "items",
            "compendiumId": "OjkIqlW2UpgFcjZa",
            "name": "Plate Armor",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_plate-armor-of-etherealness",
            "pack": "items",
            "compendiumId": "dJjdWdaZU30r1zx4",
            "name": "Plate Armor of Etherealness",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_playing-card-set",
            "pack": "items",
            "compendiumId": "YwlHI3BVJapz4a3E",
            "name": "Playing Cards Set",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_poison-basic",
            "pack": "items",
            "compendiumId": "eVbPkYjpl29RE2uW",
            "name": "Basic Poison",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_poisoners-kit",
            "pack": "items",
            "compendiumId": "il2GNi8C0DvGLL9P",
            "name": "Poisoner's Kit",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pole-10-foot",
            "pack": "items",
            "compendiumId": "tut1jbW3UCsrUjCG",
            "name": "Pole",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_portable-hole",
            "pack": "items",
            "compendiumId": "rvxGvcUzoQXVNbAu",
            "name": "Portable Hole",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pot-iron",
            "pack": "items",
            "compendiumId": "M8xM8BLK4tpUayEE",
            "name": "Iron Pot",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-animal-friendship",
            "pack": "items",
            "compendiumId": "nXWevqtV6p484N59",
            "name": "Potion of Animal Friendship",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-clairvoyance",
            "pack": "items",
            "compendiumId": "bAyr7j5Peq9wIJTa",
            "name": "Potion of Clairvoyance",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-climbing",
            "pack": "items",
            "compendiumId": "aMnWi1WXWpxRHq4r",
            "name": "Potion of Climbing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-cloud-giant-strength",
            "pack": "items",
            "compendiumId": "lAcTZgNtpmks2Mo5",
            "name": "Potion of Cloud Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-diminution",
            "pack": "items",
            "compendiumId": "HY8duCwmvlXOruTG",
            "name": "Potion of Diminution",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-fire-giant-strength",
            "pack": "items",
            "compendiumId": "bEZOY6uvHRweMM56",
            "name": "Potion of Fire Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-flying",
            "pack": "items",
            "compendiumId": "eTNc8XPtvZNe3yQs",
            "name": "Potion of Flying",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-frost-giant-strength",
            "pack": "items",
            "compendiumId": "TevMHicE3A70AlmP",
            "name": "Potion of Frost Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-gaseous-form",
            "pack": "items",
            "compendiumId": "bqZ6NTLDCUB98YjV",
            "name": "Potion of Gaseous Form",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-greater-healing",
            "pack": "items",
            "compendiumId": "L887NdWEP5NqHCrQ",
            "name": "Potion of Greater Healing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-growth",
            "pack": "items",
            "compendiumId": "gTRFQLdVD1gsKtPi",
            "name": "Potion of Growth",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-healing",
            "pack": "items",
            "compendiumId": "ytlsBjYsZ7OBSEBs",
            "name": "Potion of Healing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-heroism",
            "pack": "items",
            "compendiumId": "wNKYbKYwOHbA7SH8",
            "name": "Potion of Heroism",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-hill-giant-strength",
            "pack": "items",
            "compendiumId": "mhFBTY0egW8AeCHe",
            "name": "Potion of Hill Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-invisibility",
            "pack": "items",
            "compendiumId": "rTn4p9nJr4Aq2GPB",
            "name": "Potion of Invisibility",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-mind-reading",
            "pack": "items",
            "compendiumId": "Ct9LR9Ft1FG4a6Y1",
            "name": "Potion of Mind Reading",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-poison",
            "pack": "items",
            "compendiumId": "qBSEGJyHxdKIlBfj",
            "name": "Potion of Poison",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-speed",
            "pack": "items",
            "compendiumId": "ctKfjHjk9gs9UtZI",
            "name": "Potion of Speed",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-stone-giant-strength",
            "pack": "items",
            "compendiumId": "4ZiJsDTRA1GgcWKP",
            "name": "Potion of Stone Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-storm-giant-strength",
            "pack": "items",
            "compendiumId": "1KMSpOSU0EliUBm2",
            "name": "Potion of Storm Giant Strength",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-superior-healing",
            "pack": "items",
            "compendiumId": "5m9ErO9In8Uc5yyf",
            "name": "Potion of Superior Healing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-supreme-healing",
            "pack": "items",
            "compendiumId": "JFiSlgcm3uSSBM5t",
            "name": "Potion of Supreme Healing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potion-of-water-breathing",
            "pack": "items",
            "compendiumId": "CAZMwFBWp9VC0ZCg",
            "name": "Potion of Water Breathing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_potters-tools",
            "pack": "items",
            "compendiumId": "hJS8yEVkqgJjwfWa",
            "name": "Potter's Tools",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_pouch",
            "pack": "items",
            "compendiumId": "9bWTRRDym06PzSAf",
            "name": "Pouch",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_quarterstaff",
            "pack": "items",
            "compendiumId": "g2dWN7PQiMRYWzyk",
            "name": "Quarterstaff",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_quarterstaff-1",
            "pack": "items",
            "compendiumId": "t8L7B0JWamsvxhui",
            "name": "Quarterstaff +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_quarterstaff-2",
            "pack": "items",
            "compendiumId": "7kVZo4DLBq22406E",
            "name": "Quarterstaff +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_quarterstaff-3",
            "pack": "items",
            "compendiumId": "BmWnprrj0QWQ1BL3",
            "name": "Quarterstaff +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_quiver",
            "pack": "items",
            "compendiumId": "4MtQKPn9qMWCFjDA",
            "name": "Quiver",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ram-portable",
            "pack": "items",
            "compendiumId": "srTRzwTfWKO5opOo",
            "name": "Portable Ram",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rapier",
            "pack": "items",
            "compendiumId": "Tobce1hexTnDk4sV",
            "name": "Rapier",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rapier-1",
            "pack": "items",
            "compendiumId": "S7AhpCPDBGUBbg7b",
            "name": "Rapier +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rapier-2",
            "pack": "items",
            "compendiumId": "uLY74ppOrTaWKwer",
            "name": "Rapier +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rapier-3",
            "pack": "items",
            "compendiumId": "YevPP0DZXgAcLmzv",
            "name": "Rapier +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rations-1-day",
            "pack": "items",
            "compendiumId": "f4w4GxBi0nYXmhX4",
            "name": "Rations",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_reliquary",
            "pack": "items",
            "compendiumId": "gP1URGq3kVIIFHJ7",
            "name": "Reliquary",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_restorative-ointment",
            "pack": "items",
            "compendiumId": "VmcgAIsRCyrjBguC",
            "name": "Restorative Ointment",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-mail",
            "pack": "items",
            "compendiumId": "nsXZejlmgalj4he9",
            "name": "Ring Mail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-animal-influence",
            "pack": "items",
            "compendiumId": "ElLfmohtIFMagr5f",
            "name": "Ring of Animal Influence",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-djinni-summoning",
            "pack": "items",
            "compendiumId": "hdlBOEbEjiwUjTW5",
            "name": "Ring of Djinni Summoning",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-evasion",
            "pack": "items",
            "compendiumId": "2wxqnjpnPmkpPCC5",
            "name": "Ring of Evasion",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-feather-falling",
            "pack": "items",
            "compendiumId": "JyYwliYiWEw2g0yJ",
            "name": "Ring of Feather Falling",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-free-action",
            "pack": "items",
            "compendiumId": "i2puCDRaTxkuFfB4",
            "name": "Ring of Free Action",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-invisibility",
            "pack": "items",
            "compendiumId": "1J0dsxyKRhVXYQf5",
            "name": "Ring of Invisibility",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-jumping",
            "pack": "items",
            "compendiumId": "x7LfMrLafLKfemGH",
            "name": "Ring of Jumping",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-mind-shielding",
            "pack": "items",
            "compendiumId": "dGnkwePemh7ovuDv",
            "name": "Ring of Mind Shielding",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-protection",
            "pack": "items",
            "compendiumId": "QtmVEreNIWEVOoLR",
            "name": "Ring of Protection",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-regeneration",
            "pack": "items",
            "compendiumId": "AweD4kpKGM7Ilu3n",
            "name": "Ring of Regeneration",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-shooting-stars",
            "pack": "items",
            "compendiumId": "etA2SBgWwduCLgLT",
            "name": "Ring of Shooting Stars",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-spell-storing",
            "pack": "items",
            "compendiumId": "9cIlRtKDtDXQtElf",
            "name": "Ring of Spell Storing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-spell-turning",
            "pack": "items",
            "compendiumId": "8PI1EL8xHLq4tXKr",
            "name": "Ring of Spell Turning",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-swimming",
            "pack": "items",
            "compendiumId": "aA7MbjnpHYoYvmuW",
            "name": "Ring of Swimming",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-telekinesis",
            "pack": "items",
            "compendiumId": "hxfOtvFrY1PXHQN1",
            "name": "Ring of Telekinesis",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-the-ram",
            "pack": "items",
            "compendiumId": "qw05Om9XWqTMoio2",
            "name": "Ring of the Ram",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-three-wishes",
            "pack": "items",
            "compendiumId": "ewXgnWiYQhS8KArS",
            "name": "Ring of Three Wishes",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-warmth",
            "pack": "items",
            "compendiumId": "2veAOEyfbDJuxR8Y",
            "name": "Ring of Warmth",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-water-walking",
            "pack": "items",
            "compendiumId": "LC5LsQOPwoHQW9Mi",
            "name": "Ring of Water Walking",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_ring-of-x-ray-vision",
            "pack": "items",
            "compendiumId": "i3njMqHc689GvHDn",
            "name": "Ring of X-ray Vision",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_robe-of-eyes",
            "pack": "items",
            "compendiumId": "U74TPNQLJZbHJyCk",
            "name": "Robe of Eyes",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_robe-of-scintillating-colors",
            "pack": "items",
            "compendiumId": "JRJpKZyamkpa7awv",
            "name": "Robe of Scintillating Colors",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_robe-of-stars",
            "pack": "items",
            "compendiumId": "66UkbfH0PVwo4HgA",
            "name": "Robe of Stars",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_robe-of-the-archmagi",
            "pack": "items",
            "compendiumId": "mr96Z8YTI490ExhP",
            "name": "Robe of the Archmagi",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_robe-of-useful-items",
            "pack": "items",
            "compendiumId": "2ksm2KXCY3vBHTAx",
            "name": "Robe of Useful Items",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_robes",
            "pack": "items",
            "compendiumId": "8GCEodUsTEEpBlO6",
            "name": "Robes",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rod",
            "pack": "items",
            "compendiumId": "OojyyGfh91iViuMF",
            "name": "Rod",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rod-of-absorption",
            "pack": "items",
            "compendiumId": "6pjaQzbtxQTuQ4RW",
            "name": "Rod of Absorption",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rod-of-alertness",
            "pack": "items",
            "compendiumId": "Do3qeSHtBjUsmfvz",
            "name": "Rod of Alertness",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rod-of-lordly-might",
            "pack": "items",
            "compendiumId": "d5HNCmLIPCpPoX2w",
            "name": "Rod of Lordly Might",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rod-of-rulership",
            "pack": "items",
            "compendiumId": "vmbB2SK6pQU2Vkzb",
            "name": "Rod of Rulership",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rod-of-security",
            "pack": "items",
            "compendiumId": "9kfMsSweOBui0SC4",
            "name": "Rod of Security",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rope-hempen-50-feet",
            "pack": "items",
            "compendiumId": "QXmaarJ4X8P0C1HV",
            "name": "Hempen Rope (50 ft.)",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rope-of-climbing",
            "pack": "items",
            "compendiumId": "29e6gHwWKNLaRUoz",
            "name": "Rope of Climbing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rope-of-entanglement",
            "pack": "items",
            "compendiumId": "J8gQdJJi5e8LmD7H",
            "name": "Rope of Entanglement",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_rope-silk-50-feet",
            "pack": "items",
            "compendiumId": "oY8KbpGmB5H2Deoy",
            "name": "Silk Rope (50 ft.)",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sack",
            "pack": "items",
            "compendiumId": "CNdDj8dsXVpRVpXt",
            "name": "Sack",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_scale-mail",
            "pack": "items",
            "compendiumId": "XmnlF5fgIO3tg6TG",
            "name": "Scale Mail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_scale-merchants",
            "pack": "items",
            "compendiumId": "vJvb6fx3JVPmhG8x",
            "name": "Merchant's Scale",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_scarab-of-protection",
            "pack": "items",
            "compendiumId": "xjRSY2ECcc9viSz3",
            "name": "Scarab of Protection",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_scimitar",
            "pack": "items",
            "compendiumId": "fbC0Mg1a73wdFbqO",
            "name": "Scimitar",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_scimitar-1",
            "pack": "items",
            "compendiumId": "VGtyTdVLoWls8FL5",
            "name": "Scimitar +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_scimitar-2",
            "pack": "items",
            "compendiumId": "VHYy3ZsJNPUo1SIx",
            "name": "Scimitar +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_scimitar-3",
            "pack": "items",
            "compendiumId": "2wK9ImkAeG3Lzxa0",
            "name": "Scimitar +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_scimitar-of-speed",
            "pack": "items",
            "compendiumId": "7wY0389wscheFkIa",
            "name": "Scimitar of Speed",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sealing-wax",
            "pack": "items",
            "compendiumId": "3uEyuCfnAzGkwAn5",
            "name": "Sealing Wax",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shawm",
            "pack": "items",
            "compendiumId": "G3cqbejJpfB91VhP",
            "name": "Shawm",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shield-of-missile-attraction",
            "pack": "items",
            "compendiumId": "M5APnDW8bKQb7fHI",
            "name": "Shield of Missile Attraction",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shortbow",
            "pack": "items",
            "compendiumId": "GJv6WkD7D2J6rP6M",
            "name": "Shortbow",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shortbow-1",
            "pack": "items",
            "compendiumId": "gYDMk3LWikIP5PmA",
            "name": "Shortbow +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shortbow-2",
            "pack": "items",
            "compendiumId": "tt4WokZBZMGqgYm5",
            "name": "Shortbow +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shortbow-3",
            "pack": "items",
            "compendiumId": "egJhGFU3v5OfjPNS",
            "name": "Shortbow +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shortsword",
            "pack": "items",
            "compendiumId": "osLzOwQdPtrK3rQH",
            "name": "Shortsword",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shortsword-1",
            "pack": "items",
            "compendiumId": "sl6yiYSlqkHiVVSN",
            "name": "Shortsword +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shortsword-2",
            "pack": "items",
            "compendiumId": "b2l2ubCGSnmiTrm8",
            "name": "Shortsword +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shortsword-3",
            "pack": "items",
            "compendiumId": "uIHXYhnOwETlA5lT",
            "name": "Shortsword +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_shovel",
            "pack": "items",
            "compendiumId": "qWlXDEgqdmdZWoab",
            "name": "Shovel",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sickle",
            "pack": "items",
            "compendiumId": "i4NeNZ30ycwPDHMx",
            "name": "Sickle",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sickle-1",
            "pack": "items",
            "compendiumId": "asUgQFrF1xYeNhtW",
            "name": "Sickle +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sickle-2",
            "pack": "items",
            "compendiumId": "uRoHwk1c8e5xJjkV",
            "name": "Sickle +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sickle-3",
            "pack": "items",
            "compendiumId": "AHn15T1TOuDFS0GH",
            "name": "Sickle +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_signal-whistle",
            "pack": "items",
            "compendiumId": "z67d1DZzqDPmgEwP",
            "name": "Signal Whistle",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_signet-ring",
            "pack": "items",
            "compendiumId": "kdkpSZMUHGXGM15H",
            "name": "Signet Ring",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sling",
            "pack": "items",
            "compendiumId": "3gynWO9sN4OLGMWD",
            "name": "Sling",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sling-1",
            "pack": "items",
            "compendiumId": "6I5lt8KheTsAE4Zr",
            "name": "Sling +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sling-2",
            "pack": "items",
            "compendiumId": "9qOAoFw9dTXhJ1w0",
            "name": "Sling +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sling-3",
            "pack": "items",
            "compendiumId": "q3WqP3r2emnumyUF",
            "name": "Sling +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sling-bullets",
            "pack": "items",
            "compendiumId": "z9SbsMIBZzuhZOqT",
            "name": "Sling Bullet",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_slippers-of-spider-climbing",
            "pack": "items",
            "compendiumId": "ZgXJE9pjvZLMCeHg",
            "name": "Slippers of Spider Climbing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_smiths-tools",
            "pack": "items",
            "compendiumId": "KndVe2insuctjIaj",
            "name": "Smith's Tools",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_soap",
            "pack": "items",
            "compendiumId": "REBWkTKe6lJaIkpn",
            "name": "Soap",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sovereign-glue",
            "pack": "items",
            "compendiumId": "zJ5LhDvTxYKzPIx4",
            "name": "Sovereign Glue",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spear",
            "pack": "items",
            "compendiumId": "OG4nBBydvmfWYXIk",
            "name": "Spear",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spear-1",
            "pack": "items",
            "compendiumId": "WNdN2mBF3O7ZNcMp",
            "name": "Spear +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spear-2",
            "pack": "items",
            "compendiumId": "HeDP6dL9daVT3uj2",
            "name": "Spear +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spear-3",
            "pack": "items",
            "compendiumId": "62EaozKvcA0aSy2q",
            "name": "Spear +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-1st-level",
            "pack": "items",
            "compendiumId": "9GSfMg0VOA2b4uFN",
            "name": "Spell Scroll 1st Level",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-2nd-level",
            "pack": "items",
            "compendiumId": "XdDp6CKh9qEvPTuS",
            "name": "Spell Scroll 2nd Level",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-3rd-level",
            "pack": "items",
            "compendiumId": "hqVKZie7x9w3Kqds",
            "name": "Spell Scroll 3rd Level",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-4th-level",
            "pack": "items",
            "compendiumId": "DM7hzgL836ZyUFB1",
            "name": "Spell Scroll 4th Level",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-5th-level",
            "pack": "items",
            "compendiumId": "wa1VF8TXHmkrrR35",
            "name": "Spell Scroll 5th Level",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-6th-level",
            "pack": "items",
            "compendiumId": "tI3rWx4bxefNCexS",
            "name": "Spell Scroll 6th Level",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-7th-level",
            "pack": "items",
            "compendiumId": "mtyw4NS1s7j2EJaD",
            "name": "Spell Scroll 7th Level",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-8th-level",
            "pack": "items",
            "compendiumId": "aOrinPg7yuDZEuWr",
            "name": "Spell Scroll 8th Level",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-9th-level",
            "pack": "items",
            "compendiumId": "O4YbkJkLlnsgUszZ",
            "name": "Spell Scroll 9th Level",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spell-scroll-cantrip",
            "pack": "items",
            "compendiumId": "rQ6sO7HDWzqMhSI3",
            "name": "Spell Scroll Cantrip",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spellbook",
            "pack": "items",
            "compendiumId": "LBajgahniRJbAgDr",
            "name": "Spellbook",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spellguard-shield",
            "pack": "items",
            "compendiumId": "kpDbCYgUivh7NApp",
            "name": "Spellguard Shield",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sphere-of-annihilation",
            "pack": "items",
            "compendiumId": "2YNqk5zm9jDTvd7q",
            "name": "Sphere of Annihilation",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spike-iron",
            "pack": "items",
            "compendiumId": "RiOeHR2qaYktz5Ys",
            "name": "Iron Spike",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_splint-armor",
            "pack": "items",
            "compendiumId": "cKpJmsJmU8YaiuqG",
            "name": "Splint Armor",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sprig-of-mistletoe",
            "pack": "items",
            "compendiumId": "xDK9GQd2iqOGH8Sd",
            "name": "Sprig of Mistletoe",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_spyglass",
            "pack": "items",
            "compendiumId": "WCafDVKITxwnlf2x",
            "name": "Spyglass",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff",
            "pack": "items",
            "compendiumId": "BeKIrNIvNHRPQ4t5",
            "name": "Staff",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-charming",
            "pack": "items",
            "compendiumId": "FeouSUPUlUhfgeRp",
            "name": "Staff of Charming",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-fire",
            "pack": "items",
            "compendiumId": "lsiR1hVfISlC5YoB",
            "name": "Staff of Fire",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-frost",
            "pack": "items",
            "compendiumId": "xEtBeZjJnkDXojQM",
            "name": "Staff of Frost",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-healing",
            "pack": "items",
            "compendiumId": "WLVQJVpCWiPkCAtZ",
            "name": "Staff of Healing",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-power",
            "pack": "items",
            "compendiumId": "eM5gEe4SEOvA2Y9t",
            "name": "Staff of Power",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-striking",
            "pack": "items",
            "compendiumId": "URun3vYrXKJJdAJe",
            "name": "Staff of Striking",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-swarming-insects",
            "pack": "items",
            "compendiumId": "bod1dKzbAkAm21Ho",
            "name": "Staff of Swarming Insects",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-the-magi",
            "pack": "items",
            "compendiumId": "l3V7V8VCXpmAAysQ",
            "name": "Staff of the Magi",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-the-python",
            "pack": "items",
            "compendiumId": "MOeFq5MLAQzVQC7z",
            "name": "Staff of the Python",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-the-woodlands",
            "pack": "items",
            "compendiumId": "caEn3ixCUFBnHTx6",
            "name": "Staff of the Woodlands",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-thunder-and-lightning",
            "pack": "items",
            "compendiumId": "F6v3Q7dz1SlpLTMf",
            "name": "Staff of Thunder and Lightning",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_staff-of-withering",
            "pack": "items",
            "compendiumId": "uHL99JKLUpTKAbz8",
            "name": "Staff of Withering",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_stone-of-controlling-earth-elementals",
            "pack": "items",
            "compendiumId": "TWFS1BtruQeE10BY",
            "name": "Stone of Controlling Earth Elementals",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_stone-of-good-luck-luckstone",
            "pack": "items",
            "compendiumId": "296Zgo9RhltWShE1",
            "name": "Stone of Good Luck (Luckstone)",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_studded-leather-armor",
            "pack": "items",
            "compendiumId": "TIV3B1vbrVHIhQAm",
            "name": "Studded Leather Armor",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sun-blade",
            "pack": "items",
            "compendiumId": "yiYCqmD5n08NftYk",
            "name": "Sun Blade",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-life-stealing-greatsword",
            "pack": "items",
            "compendiumId": "sdHSbitJxgTX6aDG",
            "name": "Greatsword of Life Stealing",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-life-stealing-longsword",
            "pack": "items",
            "compendiumId": "wtctR6tCcYbQPiS0",
            "name": "Longsword of Life Stealing",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-life-stealing-rapier",
            "pack": "items",
            "compendiumId": "p01JzD9RpIOkJiqK",
            "name": "Rapier of Life Stealing",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-life-stealing-shortsword",
            "pack": "items",
            "compendiumId": "902yxeFDwavpm6cv",
            "name": "Shortsword of Life Stealing",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-sharpness-greatsword",
            "pack": "items",
            "compendiumId": "QB4CFMTLR6JlD7Kq",
            "name": "Greatsword of Sharpness",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-sharpness-longsword",
            "pack": "items",
            "compendiumId": "8MNDhKb1Q87QszOJ",
            "name": "Longsword of Sharpness",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-sharpness-scimitar",
            "pack": "items",
            "compendiumId": "ZKyhkS8ud2NpV7ng",
            "name": "Scimitar of Sharpness",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-wounding-greatsword",
            "pack": "items",
            "compendiumId": "JpwuGtFkfrGibQpP",
            "name": "Greatsword of Wounding",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-wounding-longsword",
            "pack": "items",
            "compendiumId": "pG6dddIcb9NmPrdt",
            "name": "Longsword of Wounding",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-wounding-rapier",
            "pack": "items",
            "compendiumId": "KJYqNZgdkRwPmPMl",
            "name": "Rapier of Wounding",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_sword-of-wounding-shortsword",
            "pack": "items",
            "compendiumId": "SpbjbMMoJiva2zOa",
            "name": "Shortsword of Wounding",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_talisman-of-pure-good",
            "pack": "items",
            "compendiumId": "iB3gunzgxZ8xK6Z5",
            "name": "Talisman of Pure Good",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_talisman-of-the-sphere",
            "pack": "items",
            "compendiumId": "46ikeR4RrSim6DsN",
            "name": "Talisman of the Sphere",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_talisman-of-ultimate-evil",
            "pack": "items",
            "compendiumId": "PAXfmZ2ErDlCVy0N",
            "name": "Talisman of Ultimate Evil",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_tent",
            "pack": "items",
            "compendiumId": "PanSr5EbqlfpSvwK",
            "name": "Two-Person Tent",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_thieves-tools",
            "pack": "items",
            "compendiumId": "woWZ1sO5IUVGzo58",
            "name": "Thieves' Tools",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_tinderbox",
            "pack": "items",
            "compendiumId": "DNOSEAvF4Oh1DlWy",
            "name": "Tinderbox",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_tinkers-tools",
            "pack": "items",
            "compendiumId": "0d08g1i5WXnNrCNA",
            "name": "Tinker's Tools",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_tome-of-clear-thought",
            "pack": "items",
            "compendiumId": "2BYm8to5KldN8eYu",
            "name": "Tome of Clear Thought",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_tome-of-leadership-and-influence",
            "pack": "items",
            "compendiumId": "oN4Glcmi4BhdAI3k",
            "name": "Tome of Leadership and Influence",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_tome-of-understanding",
            "pack": "items",
            "compendiumId": "WnKWD1FuAFUE7f4v",
            "name": "Tome of Understanding",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_torch",
            "pack": "items",
            "compendiumId": "BnOCLuNWhVvzHLjl",
            "name": "Torch",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_totem",
            "pack": "items",
            "compendiumId": "PGL6aaM0wE5h0VN5",
            "name": "Totem",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_trident",
            "pack": "items",
            "compendiumId": "F65ANO66ckP8FDMa",
            "name": "Trident",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_trident-1",
            "pack": "items",
            "compendiumId": "vuThcmO7MYlw5b9f",
            "name": "Trident +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_trident-2",
            "pack": "items",
            "compendiumId": "EkTpM4Wbsrdqflzl",
            "name": "Trident +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_trident-3",
            "pack": "items",
            "compendiumId": "z9fFB1uaGJvcXTf7",
            "name": "Trident +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_trident-of-fish-command",
            "pack": "items",
            "compendiumId": "o4Irx3hHiD3FnPbL",
            "name": "Trident of Fish Command",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_truth-serum",
            "pack": "items",
            "compendiumId": "a86F565Pjdzym1jH",
            "name": "Truth Serum",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_universal-solvent",
            "pack": "items",
            "compendiumId": "MAwoj2suj6cvb9Ti",
            "name": "Universal Solvent",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vial",
            "pack": "items",
            "compendiumId": "meJEfX3gZgtMX4x2",
            "name": "Vial",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-battleaxe",
            "pack": "items",
            "compendiumId": "dG7iFak1YH1nXRpC",
            "name": "Vicious Battleaxe",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-blowgun",
            "pack": "items",
            "compendiumId": "ozYrQ5N4s81h35Fa",
            "name": "Vicious Blowgun",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-club",
            "pack": "items",
            "compendiumId": "UctSPehpKb4lJQGr",
            "name": "Vicious Club",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-crossbow-hand",
            "pack": "items",
            "compendiumId": "K7h4LT03SNt2807z",
            "name": "Vicious Hand Crossbow",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-crossbow-heavy",
            "pack": "items",
            "compendiumId": "Fk78kNmp3OLX5EMC",
            "name": "Vicious Heavy Crossbow",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-crossbow-light",
            "pack": "items",
            "compendiumId": "VQAUcjn1qdwW3MeU",
            "name": "Vicious Light Crossbow",
            "match": "manual"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-dagger",
            "pack": "items",
            "compendiumId": "5Jz5w7XJxgtlsx6K",
            "name": "Vicious Dagger",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-dart",
            "pack": "items",
            "compendiumId": "jeoZmDD9fuQdvC77",
            "name": "Vicious Dart",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-flail",
            "pack": "items",
            "compendiumId": "qmuOeNsOKwkn6K8W",
            "name": "Vicious Flail",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-glaive",
            "pack": "items",
            "compendiumId": "eKip69fExSYN661B",
            "name": "Vicious Glaive",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-greataxe",
            "pack": "items",
            "compendiumId": "nY6CnKEHyJ5STgt5",
            "name": "Vicious Greataxe",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-greatclub",
            "pack": "items",
            "compendiumId": "p9dtQU9wEZGumHSb",
            "name": "Vicious Greatclub",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-greatsword",
            "pack": "items",
            "compendiumId": "FpLaviCom3XR1ckP",
            "name": "Vicious Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-halberd",
            "pack": "items",
            "compendiumId": "isKR904LkLaH4i6M",
            "name": "Vicious Halberd",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-handaxe",
            "pack": "items",
            "compendiumId": "QM3gdsL0eaAus7XT",
            "name": "Vicious Handaxe",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-javelin",
            "pack": "items",
            "compendiumId": "lM5uo6R4gy8rJG5Y",
            "name": "Vicious Javelin",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-lance",
            "pack": "items",
            "compendiumId": "r8yK6SrWOz4hqF01",
            "name": "Vicious Lance",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-light-hammer",
            "pack": "items",
            "compendiumId": "4MeSq8KcF7KK7emF",
            "name": "Vicious Light Hammer",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-longbow",
            "pack": "items",
            "compendiumId": "gVo3UbvwjFIiFR0c",
            "name": "Vicious Longbow",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-longsword",
            "pack": "items",
            "compendiumId": "pC3202gDTy8G5i4r",
            "name": "Vicious Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-mace",
            "pack": "items",
            "compendiumId": "gSwpQacBLOJeLWrK",
            "name": "Vicious Mace",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-maul",
            "pack": "items",
            "compendiumId": "6JbrdSg5YYbs9ANm",
            "name": "Vicious Maul",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-morningstar",
            "pack": "items",
            "compendiumId": "Vm6SuX6TkDvSIVGr",
            "name": "Vicious Morningstar",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-pike",
            "pack": "items",
            "compendiumId": "zibIgdxPz8QHSCg6",
            "name": "Vicious Pike",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-quarterstaff",
            "pack": "items",
            "compendiumId": "Z7xno2zMzRtqqUIQ",
            "name": "Vicious Quarterstaff",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-rapier",
            "pack": "items",
            "compendiumId": "h0XLhuUQ0vSnW3DU",
            "name": "Vicious Rapier",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-scimitar",
            "pack": "items",
            "compendiumId": "FHUDEygUW7EWCDgA",
            "name": "Vicious Scimitar",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-shortbow",
            "pack": "items",
            "compendiumId": "Z0eO3TTpYA2hjwdd",
            "name": "Vicious Shortbow",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-shortsword",
            "pack": "items",
            "compendiumId": "1PMaZR6CX8fUnOZd",
            "name": "Vicious Shortsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-sickle",
            "pack": "items",
            "compendiumId": "AChuumAYmts5uGFT",
            "name": "Vicious Sickle",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-sling",
            "pack": "items",
            "compendiumId": "qGRN4wvZLJ8uITf2",
            "name": "Vicious Sling",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-spear",
            "pack": "items",
            "compendiumId": "e7JpVX2549vp9mgF",
            "name": "Vicious Spear",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-trident",
            "pack": "items",
            "compendiumId": "TMqS62qjBCveT1Ss",
            "name": "Vicious Trident",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-war-pick",
            "pack": "items",
            "compendiumId": "g8DG0jXlvfP3uTtZ",
            "name": "Vicious War Pick",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-warhammer",
            "pack": "items",
            "compendiumId": "HnJqfKkYXIWo2sp9",
            "name": "Vicious Warhammer",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vicious-weapon-whip",
            "pack": "items",
            "compendiumId": "luTJgPXN5n0EN7iy",
            "name": "Vicious Whip",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_viol",
            "pack": "items",
            "compendiumId": "baoe3U5BfMMMxhCU",
            "name": "Viol",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vorpal-sword-greatsword",
            "pack": "items",
            "compendiumId": "3FNyS6DeCBZzFbqU",
            "name": "Vorpal Greatsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vorpal-sword-longsword",
            "pack": "items",
            "compendiumId": "HokQ1loVJTFxt27u",
            "name": "Vorpal Longsword",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_vorpal-sword-scimitar",
            "pack": "items",
            "compendiumId": "I7cOsXsklWkzouHA",
            "name": "Vorpal Scimitar",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand",
            "pack": "items",
            "compendiumId": "KA2P6I48iOWlnboO",
            "name": "Wand",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-binding",
            "pack": "items",
            "compendiumId": "7jEKkA9qbwJ3IuCb",
            "name": "Wand of Binding",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-enemy-detection",
            "pack": "items",
            "compendiumId": "5Rxo4K9cgpwgW9vZ",
            "name": "Wand of Enemy Detection",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-fear",
            "pack": "items",
            "compendiumId": "EJFql4aNWHHJSxT9",
            "name": "Wand of Fear",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-fireballs",
            "pack": "items",
            "compendiumId": "DoSvjhRARhRqWZXg",
            "name": "Wand of Fireballs",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-lightning-bolts",
            "pack": "items",
            "compendiumId": "bPFVfq81EsMNu6OQ",
            "name": "Wand of Lightning Bolts",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-magic-detection",
            "pack": "items",
            "compendiumId": "18fbyArtidKzON01",
            "name": "Wand of Magic Detection",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-magic-missiles",
            "pack": "items",
            "compendiumId": "1taRIMF9w7jpnonN",
            "name": "Wand of Magic Missiles",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-paralysis",
            "pack": "items",
            "compendiumId": "GcpXNc4dKUNw0Tk6",
            "name": "Wand of Paralysis",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-polymorph",
            "pack": "items",
            "compendiumId": "khyjT3dKyoEOf4eA",
            "name": "Wand of Polymorph",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-secrets",
            "pack": "items",
            "compendiumId": "VQ6NWjWV37wiB29O",
            "name": "Wand of Secrets",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-the-war-mage-1",
            "pack": "items",
            "compendiumId": "OPbdSlrhkUDNpgcS",
            "name": "Wand of the War Mage +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-the-war-mage-2",
            "pack": "items",
            "compendiumId": "k3T7tpcdzDyVKlF4",
            "name": "Wand of the War Mage +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-the-war-mage-3",
            "pack": "items",
            "compendiumId": "IuVaBrq17AqxpXc4",
            "name": "Wand of the War Mage +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-web",
            "pack": "items",
            "compendiumId": "4sR5HOah6KwVPHOb",
            "name": "Wand of Web",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wand-of-wonder",
            "pack": "items",
            "compendiumId": "lPsueMv4ZoXqCYf9",
            "name": "Wand of Wonder",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_war-pick",
            "pack": "items",
            "compendiumId": "2YdfjN1PIIrSHZii",
            "name": "War Pick",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_war-pick-1",
            "pack": "items",
            "compendiumId": "l2T46xCqUbJvKE7A",
            "name": "War Pick +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_war-pick-2",
            "pack": "items",
            "compendiumId": "RbC0UCqAnQcIPIXZ",
            "name": "War Pick +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_war-pick-3",
            "pack": "items",
            "compendiumId": "nrvAo3TznyQrHS1t",
            "name": "War Pick +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_warhammer",
            "pack": "items",
            "compendiumId": "F0Df164Xv1gWcYt0",
            "name": "Warhammer",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_warhammer-1",
            "pack": "items",
            "compendiumId": "8N1GqcdroUpmM9dS",
            "name": "Warhammer +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_warhammer-2",
            "pack": "items",
            "compendiumId": "KvIlZssYEtQ4bvSE",
            "name": "Warhammer +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_warhammer-3",
            "pack": "items",
            "compendiumId": "setcTdSZ09rmsqMn",
            "name": "Warhammer +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_waterskin",
            "pack": "items",
            "compendiumId": "Uv0ilmzbWvqmlCVH",
            "name": "Waterskin",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_weavers-tools",
            "pack": "items",
            "compendiumId": "ap9prThUB2y9lDyj",
            "name": "Weaver's Tools",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_well-of-many-worlds",
            "pack": "items",
            "compendiumId": "xjme5oSQZmdAy1fc",
            "name": "Well of Many Worlds",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_whetstone",
            "pack": "items",
            "compendiumId": "SuQmsJfxyJl2hPcM",
            "name": "Whetstone",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_whip",
            "pack": "items",
            "compendiumId": "QKTyxoO0YDnAsbYe",
            "name": "Whip",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_whip-1",
            "pack": "items",
            "compendiumId": "lcqqW2vGF6P8nJ77",
            "name": "Whip +1",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_whip-2",
            "pack": "items",
            "compendiumId": "WlPzuxaVnYzxzDEC",
            "name": "Whip +2",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_whip-3",
            "pack": "items",
            "compendiumId": "jcQqI0pxLD2nNNQ4",
            "name": "Whip +3",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wind-fan",
            "pack": "items",
            "compendiumId": "mYFfH24uzuKh4IPS",
            "name": "Wind Fan",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_winged-boots",
            "pack": "items",
            "compendiumId": "YjImJ3cVnArHH4ES",
            "name": "Winged Boots",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wings-of-flying",
            "pack": "items",
            "compendiumId": "FkDyLSpiynKTQZdi",
            "name": "Wings of Flying",
            "match": "exact"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_woodcarvers-tools",
            "pack": "items",
            "compendiumId": "xKErqkLo4ASYr5EP",
            "name": "Woodcarver's Tools",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_wooden-staff",
            "pack": "items",
            "compendiumId": "FF1ktpb2YSiyv896",
            "name": "Wooden Staff",
            "match": "normalized"
        },
        {
            "kind": "item",
            "upstreamKey": "srd_yew-wand",
            "pack": "items",
            "compendiumId": "t5yP0d7YaKwuKKiH",
            "name": "Yew Wand",
            "match": "normalized"
        }
    ],
    "unmatched": {
        "pack": [
            "monsters/BTQz2q4JJVQn8W5W",
            "monsters/JNmHqTwkWayvkH37",
            "monsters/Tac7eq0AXJco0nml",
            "monsters/UrXp9O9N7DvdH9nL",
            "monsters/XiSWKZzAUxdmFOLL",
            "monsters/iHj5Tkm6HRgXuaWP",
            "monsters/rLl22hYeAH3ljhdI",
            "monsters/tuHyePQ9GazMTyc0",
            "monsters/zwT2WjWo7cTm2631",
            "items/00BggOkChWztQx6R",
            "items/07R6JFioylOCpVoL",
            "items/0ZBWwjFz3nIAXMLW",
            "items/23y8FvWKf9YLcnBL",
            "items/34YKlIJVVWLeBv7R",
            "items/3X7vdOjnCSpi40yn",
            "items/3b0RvGi0TnTYpIxn",
            "items/3nVvaHVfHsgwGlkL",
            "items/41kYCmKq0PbGVKaM",
            "items/466j8hy4AiENMHVQ",
            "items/4932CLHvjZYxOm4g",
            "items/5SorTMl8NKDO9Yge",
            "items/6BybWxK5GcEzqcOV",
            "items/6OIw31CDF6mAwFnd",
            "items/6OYR11aJX2dEVtOj",
            "items/7ztvHyYJCcOOAWmR",
            "items/84z9mVy1mCipUWEY",
            "items/8CaODbNQtxHGuVjn",
            "items/8KWz5DJbWUpNWniP",
            "items/8MPnSrvEeZhPhtTi",
            "items/8l7M3zeqrU2vkA5h",
            "items/9Ifr8fGvJ1bArzOW",
            "items/9Mdes2tKt0cqsNTw",
            "items/9uT9SXy1Gb1jiiZX",
            "items/BNJmdttKvIwC08Pd",
            "items/BwC8hZaNjO7IQc6K",
            "items/CwWbeQ6XyqFzbMYw",
            "items/DeK9uQvNJj3JzFwe",
            "items/DnlQkH6Bpwkd5n5Y",
            "items/DxIdfGoJEYQj8o3D",
            "items/E7c4zpWdYgkKDHGo",
            "items/ET8Oo5vaTZqyb7rN",
            "items/FLoBS3UnFnZTSsSx",
            "items/FZixEM5voQkH84xP",
            "items/Fgkj11diTJJ7H3JC",
            "items/G9XQPNLlDXkpVxn1",
            "items/GsuvwoekKZatfKwF",
            "items/HLEhnzLbpRbYdAHo",
            "items/HnIERWmmra74hSCw",
            "items/HpEEfZg9PRkXnMi4",
            "items/IGwDN9gtYxCrlrCr",
            "items/IY5PveXrF7VoFlWg",
            "items/IeM5Ha2cg0RA99q3",
            "items/Ilyv71AeobM6AvIn",
            "items/IpBBqr0r7JanyVn0",
            "items/IrC5LPbWNxlAQoK7",
            "items/JDTO996oInbiZGHW",
            "items/Jj4iFQQGvckx8Wsj",
            "items/KJuLguMZCThrQOEx",
            "items/KhRhwADrTpol3yTx",
            "items/L4PxYPtYca283sju",
            "items/L9KBLub5vfb3mTDz",
            "items/LBQWNqX6hZOKhQ8a",
            "items/LHaqMvrx3PfSzWMQ",
            "items/M28HYDCueaK7J8u8",
            "items/MSO3JxK8578xSh6x",
            "items/Mj8fTo5VZKJJ7uMv",
            "items/N0in6FE8DQdZrHei",
            "items/NM1dPyKwHw2DyUWA",
            "items/NYIib9KEYDUFe9GY",
            "items/Nd4r4hocpfu6fYDP",
            "items/NgwrqNa6kkgoPW2Q",
            "items/NjTgPn2o0M1TGk93",
            "items/PLkzJ310FzBnRrI5",
            "items/Q7E6MgPzVkwBeZ6l",
            "items/Qy2aRjl4iQ8EmaT5",
            "items/Rn9gt6JGULtx9Zvz",
            "items/STxsp9Ao3pS2T4gt",
            "items/ScxK8YNU5dWELhlQ",
            "items/TZggpdbOYqOCG7mY",
            "items/TjWk2mpNXjDdfIDM",
            "items/TmfaFUSZJAotndn9",
            "items/ULL5nkyN3WzazI4l",
            "items/UOE8RGOpgv2oWIvM",
            "items/UT8zCwmdXVQlBiyl",
            "items/UgnUJhu0tW1tLt7g",
            "items/VTc5McIjCm40KPIz",
            "items/WO8DLfz3G2QZ5njs",
            "items/WfqBg3yBNoJQtVEB",
            "items/XAr1SR4POx5BAArk",
            "items/XJ8CG4UvLELCmOi2",
            "items/XJFqU9COdk4ycFa2",
            "items/XKnDE8DTrJxIkVCF",
            "items/XXLznzi3rlanMhTM",
            "items/XY8b594Dn7plACLL",
            "items/XZWHQ20ynJBK6xmU",
            "items/XwqNHyox5OQQio8q",
            "items/YFarUKR3OrM5raf5",
            "items/ZLpj1bpnWlAFUEHE",
            "items/Zf7kBZa5f4WBepn1",
            "items/ZjUOHSyND2VFXQeP",
            "items/ZwFCZDgQljlidzns",
            "items/aDEAwKwttl35dWaB",
            "items/akjpaK4TYkUZbGrN",
            "items/c0luemOP0iW8L23R",
            "items/cI0UhWUux8gIzSHn",
            "items/dOZkW5MwvsMhnd08",
            "items/dXtZxlh2VKLCo1nA",
            "items/dsjke4vPPsc9gsxH",
            "items/dvNzJqb7vq6oJlA2",
            "items/e98hfROZjztt7ccO",
            "items/eHGbr3rqRRxdBPLq",
            "items/eJY20LOs3pOkRDPl",
            "items/ecz2fVDyAg8YgJGe",
            "items/f5chGcpQCi1HYPQw",
            "items/fO1PuSOtZWLzEHqu",
            "items/fStHPOhuJvwEjzQh",
            "items/feKHv3JUWZdSNKf0",
            "items/fvezXwRJ5PqUf5NN",
            "items/g8fQZ1WyTz2bTtvA",
            "items/gLkbbUtGhQgYANM8",
            "items/gwuffGC4JZ8BbStz",
            "items/hWqImieUaLo08l9l",
            "items/iLt7wTWr4cJnQulJ",
            "items/iOMRrzfzFCfPGuD6",
            "items/ig5DOQtQYJPXJId4",
            "items/irtqrzaUCeshmTZp",
            "items/k2B9P3gm2NGjJ1m0",
            "items/kKGJjVVlJVoakWgQ",
            "items/kOYXMf4GTtD7OqbD",
            "items/l794iywHk8Wc6Uvi",
            "items/lHS63sC6bypENNlR",
            "items/nXWdGtzi8DXDLLsL",
            "items/odV5cq2HSLSCH69k",
            "items/qMGkmzfLHfXd7DiJ",
            "items/qVHCzgVvOZAtuk4N",
            "items/sfegfmo59MHJg2YC",
            "items/tEWhsb2lYF4uvF0z",
            "items/twRJhPtDQe1HceFt",
            "items/uw6fINSmZ2j2o57A",
            "items/vpenjFjUyEBLLlUc",
            "items/x1GUgZYjMubaFavx",
            "items/x9I9vdo4kafHDjcO",
            "items/xbVpKtrQ6tJsPhXX",
            "items/xsB7Y2WI476kvOt4",
            "items/xw99pcqPBVwtMOLw",
            "items/xzZQIIxXjNJwNqnp",
            "items/zBX8LLC2CjC89Dzl",
            "items/zDJ4oEt5HArN1xmP",
            "items/zIpNJyuOxp2raizE",
            "items/zSKorO6lwT7vs2uk",
            "items/zgZkJAyFAfYmyn11"
        ],
        "srd": [
            "srd_donkey",
            "srd_elf-drow",
            "srd_gnome-deep-svirfneblin",
            "item/srd_goat",
            "srd_acid",
            "srd_assassins-blood",
            "srd_bag-of-tricks",
            "srd_burnt-othur-fumes",
            "srd_canvas",
            "srd_carpet-of-flying",
            "srd_carriage",
            "srd_cart",
            "srd_chariot",
            "srd_chicken",
            "srd_cinnamon",
            "srd_cloves",
            "srd_copper",
            "srd_copper-piece",
            "srd_cotton-cloth",
            "srd_cow",
            "srd_crawler-mucus",
            "srd_drow-poison",
            "srd_electrum-piece",
            "srd_elemental-gem",
            "srd_essense-of-either",
            "srd_feather-token",
            "srd_figurine-of-wondrous-power-ivory-goats",
            "srd_flask-or-tankard",
            "srd_flour",
            "srd_galley",
            "srd_ginger",
            "srd_gold",
            "srd_gold-piece",
            "srd_iron",
            "srd_jug-or-pitcher",
            "srd_keelboat",
            "srd_linen",
            "srd_longship",
            "srd_malice",
            "srd_midnight-tears",
            "srd_oil-of-taggit",
            "srd_ox",
            "srd_pale-tincture",
            "srd_pepper",
            "srd_pig",
            "srd_platinum",
            "srd_platinum-piece",
            "srd_potion-of-resistance",
            "srd_purple-worm-poison",
            "srd_ring-of-elemental-command",
            "srd_ring-of-resistance",
            "srd_rowboat",
            "srd_saffron",
            "srd_sailing-ship",
            "srd_salt",
            "srd_serpent-venom",
            "srd_sheep",
            "srd_silk",
            "srd_silver",
            "srd_silver-piece",
            "srd_sled",
            "srd_sword-of-sharpness-shortsword",
            "srd_torpor",
            "srd_vicious-weapon-net",
            "srd_vorpal-sword-shortsword",
            "srd_wagon",
            "srd_warship",
            "srd_wheat",
            "srd_wyvern-poison"
        ]
    }
}
